import React from 'react';
import { notification } from 'antd';
import styled from 'styled-components';
import moment from 'moment';
import cloneDeep from 'lodash/cloneDeep';

import cn from 'classnames';
import { getColorFilters } from '../icons/utils';
import styles from '../icons/Icons.module.scss';
import colors from '../stylesheets/variables.scss';

import { subContractService, userService } from '../services';
import {
  CompanyHelmetIcon,
  MachineryIcon,
  MaterialIcon,
  FileIcon,
  CycleIcon,
  EnvironmentIcon,
  SafetyIcon,
  PreviousIcon,
  QualityIcon,
  OthersIcon,
  SubmittalIcon,
  ContractIcon,
  UserIcon,
  ReorderIcon,
  RulerIcon
} from '../icons';
import { TimerManagerSingleton } from './timerManager';

export const checkAllFieldsValid = (formValues) => {
  const aux = cloneDeep(formValues);
  return !Object.keys(aux)
    .map((x) => formValues[x])
    .some((field) => !field.valid);
};

export function hexToRgb(hex, alpha = 1) {
  // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
  const shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
  hex = hex.replace(shorthandRegex, (m, r, g, b) => r + r + g + g + b + b);

  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result
    ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16),
        a: alpha
      }
    : null;
}

export const isColorLight = (rgbColor) => {
  if (!rgbColor) {
    return false;
  }

  const { r, g, b } = rgbColor;
  const brightness = (r * 299 + g * 587 + b * 114) / 1000;
  return brightness > 128;
};

export const getCompanyTextColor = (hexColor) => {
  if (!hexColor) {
    return '#121212';
  }

  const rgb = hexToRgb(hexColor);
  if (isColorLight(rgb)) {
    return '#121212';
  }

  return '#FFFFFF';
};

export const reduceFormValues = (formElements, state, letArrNames = false) => {
  const arrElements = Array.prototype.slice.call(formElements);
  const passwordField = arrElements.find((elem) => elem.name === 'password');

  const formValues = arrElements
    .filter((elem) => elem.name.length > 0)
    .map((x) => {
      const { typeMismatch } = x.validity;
      const { name, type, value } = x;
      let validValue = x.checkValidity();
      // type repassword
      if (x.name === 'repassword' && x.value !== passwordField.value) {
        validValue = false;
      }
      // type checkbox
      if (x.type === 'checkbox' && x.checked === false) {
        validValue = false;
      }
      // type text (whitespace characters)
      if (
        x.type === 'text' &&
        x.value.trim() == '' &&
        window.location.href.includes('confirmation') &&
        !window.location.href.includes('confirmationproject')
      ) {
        validValue = false;
      }
      // type select (multiples selects)
      if (!letArrNames) {
        if (x.type === 'select-one' && x.value === -1) {
          validValue = false;
        }
      }
      // type text (whitespace characters)
      // if (x.type === 'text' && x.value.trim() == '') {
      //    validValue = false
      // }
      return {
        name,
        type,
        typeMismatch,
        value,
        valid: validValue
      };
    })
    .reduce((acc, currVal, i) => {
      const { value, valid, typeMismatch } = currVal;
      if (!state[currVal.name]) {
      }
      const { fieldName, requiredTxt, formatErrorTxt } = state[currVal.name];

      let arrIndex = currVal.name;
      if (letArrNames) {
        arrIndex = currVal.name + i;
      }

      acc[arrIndex] = {
        value,
        valid,
        typeMismatch,
        fieldName,
        requiredTxt,
        formatErrorTxt
      };

      return acc;
    }, {});

  return formValues;
};

export const buildPassword = (len = 10) => {
  let a = '';
  const b = 'abcdefghijklmnopqrstuvwxyz1234567890';
  for (let ma = 0; ma < len; ma++) {
    a += b[Math.floor(Math.random() * b.length)];
  }
  return a;
};

export const txtFieldState = {
  value: '',
  valid: true,
  typeMismatch: false,
  errMsg: ''
};

export const week_days = [
  { value: 0, label: 'Domingo', trad: 'sunday' },
  { value: 1, label: 'Lunes', trad: 'monday' },
  { value: 2, label: 'Martes', trad: 'tuesday' },
  { value: 3, label: 'Miércoles', trad: 'wednesday' },
  { value: 4, label: 'Jueves', trad: 'thursday' },
  { value: 5, label: 'Viernes', trad: 'friday' },
  { value: 6, label: 'Sábado', trad: 'saturday' }
];

export const rollingTypes = ['disabled', 'weekly'];

export const release_constraint_options = (t) => [
  {
    value: 'editable',
    label: t('settings.project_form.release_constraint_editable')
  },
  {
    value: 'no-editable',
    label: t('settings.project_form.release_constraint_not_editable')
  }
];

export const typesCreaters = [
  { value: 'duration', label: 'Duración', trad: 'duration' },
  { value: 'cost', label: 'Costo', trad: 'cost' }
];

export const companySizes = [
  { value: 'a', label: '1-4' },
  { value: 'b', label: '5-10' },
  { value: 'c', label: '11-15' },
  { value: 'd', label: '16-20' },
  { value: 'e', label: '21-30' },
  { value: 'f', label: '31-50' },
  { value: 'g', label: '+50' }
];

export const companyContractType = [
  { value: 'project_based', label: 'Project Based' },
  { value: 'enterprise', label: 'Enterprise' }
];

export const Types = [
  { value: 'commercial2', label: 'Centros Comerciales', trad: 'type_com2' },
  { value: 'datacenter', label: 'Centros de datos', trad: 'type_data' },
  { value: 'commercial', label: 'Comercial', trad: 'type_com' },
  { value: 'sports', label: 'Deportivo', trad: 'type_sport' },
  { value: 'residential', label: 'Edificación en altura', trad: 'type_res' },
  {
    value: 'residential2',
    label: 'Edificación en extensión',
    trad: 'type_res2'
  },
  { value: 'education', label: 'Educación', trad: 'type_edu' },
  { value: 'government', label: 'Gubernamental', trad: 'type_gov' },
  { value: 'hotel', label: 'Hotel', trad: 'type_hotel' },
  { value: 'infrastructure', label: 'Infraestructura', trad: 'type_inf' },
  { value: 'industrial', label: 'Montaje Industrial', trad: 'type_ind' },
  { value: 'mining', label: 'Minería', trad: 'type_min' },
  { value: 'office', label: 'Oficina', trad: 'type_off' },
  { value: 'religious', label: 'Religioso', trad: 'type_rel' },
  { value: 'interiors', label: 'Remodelación interior', trad: 'type_int' },
  { value: 'healthcare', label: 'Salud', trad: 'type_health' },
  { value: 'improvement', label: 'Mejora del inquilino', trad: 'type_tenant' },
  { value: 'biotech', label: 'Biotecnología', trad: 'type_bio' }
];

export const projectSizesTypes = [
  { value: 'm2', label: 'm2' },
  { value: 'HH', label: 'HH' },
  { value: 'ft2', label: 'ft2' },
  { value: 'm', label: 'm' },
  { value: 'kw', label: 'kW' }
];

// https://es.wikipedia.org/wiki/ISO_4217
export const projectCurrency = (t) => [
  { value: 'CLP', label: t('currencys.clp') },
  { value: 'UF', label: t('currencys.uf') },
  { value: 'USD', label: t('currencys.usd') },
  { value: 'EUR', label: t('currencys.eur') },
  { value: 'PEN', label: t('currencys.pen') },
  { value: 'ARS', label: t('currencys.ars') },
  { value: 'UYU', label: t('currencys.uyu') },
  { value: 'BRL', label: t('currencys.brl') },
  { value: 'COP', label: t('currencys.cop') },
  { value: 'MXN', label: t('currencys.mxn') },
  { value: 'BOB', label: t('currencys.bob') },
  { value: 'VES', label: t('currencys.ves') },
  { value: 'GYD', label: t('currencys.gyd') },
  { value: 'SRD', label: t('currencys.srd') },
  { value: 'TTD', label: t('currencys.ttd') },
  { value: 'RP', label: 'Indonesian Rupiah' },
  { value: 'CAD', label: t('currencys.cad') },
  { value: 'GBP', label: t('currencys.gbp') }
];

export const analitycPanels = (t) => [
  { value: 'gen', label: t('analitic.panels.general') },
  { value: 'plan', label: t('analitic.panels.plan') },
  { value: 'constraint', label: t('analitic.panels.constraint') },
  { value: 'continuous', label: t('analitic.panels.continuous_improvement') },
  { value: 'takt', label: t('analitic.takt') },
  { value: 'resource', label: t('analitic.panels.resource') },
  { value: 'productivity', label: t('analitic.panels.productivity') }
];

/** Enum for Stage for projects */
export const Stage = [
  'started',
  'inoperation',
  'suspended',
  'stopped',
  'finished',
  'archived',
  'deleted'
];

export const StageTypes = Object.freeze({
  STARTED: 'started',
  INOPERATION: 'inoperation',
  SUSPENDED: 'suspended',
  STOPPED: 'stopped',
  FINISHED: 'finished',
  ARCHIVED: 'archived',
  DELETED: 'deleted'
});

/** Enum for Reason Archive for projects */
export const ReasonsArchive = (t) => [
  { value: 'finished', label: t('project_delete.finished') },
  { value: 'stopped', label: t('project_delete.stopped') },
  { value: 'lookingfor', label: t('project_delete.lookingfor') },
  { value: 'other', label: t('project_delete.other') }
];

export const Stages = (t) => [
  { value: 'started', label: t('started_label') },
  { value: 'inoperation', label: t('inoperation_label') },
  { value: 'suspended', label: t('suspended_label') },
  { value: 'stopped', label: t('stopped_label') },
  { value: 'finished', label: t('finished_label') },
  { value: 'archived', label: t('archived_label') },
  { value: 'deleted', label: t('deleted_label') }
];

export const taskStatus = (t) => [
  { value: 'Doing', label: t('tables.gantt.status.options.Doing') },
  { value: 'Done', label: t('tables.gantt.status.options.Done') },
  { value: 'Overdue', label: t('tables.gantt.status.options.Overdue') },
  { value: 'Waiting', label: t('tables.gantt.status.options.Waiting') },
  { value: 'Advancement', label: t('tables.gantt.status.options.Advancement') }
];

export const filterProjectsList = [
  { value: 'stage', label: 'Status' },
  { value: 'country', label: 'Location' },
  { value: 'type', label: 'Type' }
];

export const userType = (t) => [
  { value: 'superadmin', label: t('positions.superadmin') },
  { value: 'admin', label: t('positions.admin') },
  { value: 'projectleader', label: t('positions.projectleader') },
  { value: 'planner', label: t('positions.planner') },
  {
    value: 'superintendent',
    label: t('positions.fieldprofessional')
  } /** old fieldprofessional */,
  { value: 'subtrade', label: t('positions.subtrade') },
  { value: 'lastplanner', label: t('positions.lastplanner') },
  { value: 'client', label: t('positions.client') },
  { value: 'manager', label: t('positions.manager') }
];

export const resourcesType = (t) => [
  { value: 'material', label: t('master_plan_resources.material') },
  { value: 'machinery', label: t('master_plan_resources.machinery') },
  { value: 'rrhh', label: t('master_plan_resources.speciality') }
];

export const categoriesConstraintType = [
  {
    value: 'design',
    label: 'Design',
    labelEs: 'Diseño',
    icon: 'ds',
    trad: 'design'
  },
  {
    value: 'rrhh',
    label: 'Labor',
    labelEs: 'Mano de Obra',
    icon: 'mo',
    trad: 'labor'
  },
  {
    value: 'machinery',
    label: 'Equipment',
    labelEs: 'Equipos / Maquinaria',
    icon: 'ma',
    trad: 'machinery_and_equipment'
  },
  {
    value: 'material',
    label: 'Material',
    labelEs: 'Materiales',
    icon: 'mat',
    trad: 'materials'
  },
  {
    value: 'permissions',
    label: 'Permit',
    labelEs: 'Permisos',
    icon: 'pe',
    trad: 'permits'
  },
  {
    value: 'provider',
    label: 'Supply Chain',
    labelEs: 'Proveedores',
    icon: 'pr',
    trad: 'suppliers'
  },
  {
    value: 'ambient',
    label: 'Environment',
    labelEs: 'Medio Ambiente',
    icon: 'me',
    trad: 'environment'
  },
  {
    value: 'risks',
    label: 'Safety',
    labelEs: 'Seguridad',
    icon: 'sg',
    trad: 'security'
  },
  {
    value: 'activity',
    label: 'Predecessor',
    labelEs: 'Actividad Predecesora',
    icon: 'ap',
    trad: 'predecessor'
  },
  {
    value: 'procedure',
    label: 'Quality',
    labelEs: 'Calidad',
    icon: 'do',
    trad: 'procedure'
  },
  {
    value: 'others',
    label: 'Others',
    labelEs: 'Otros',
    icon: 'ot',
    trad: 'others'
  },
  {
    value: 'submittal',
    label: 'Submittal',
    labelEs: 'Documentación',
    icon: 'sub',
    trad: 'submittal'
  },
  {
    value: 'contract',
    label: 'Contract',
    labelEs: 'Contratos',
    icon: 'con',
    trad: 'contract'
  },
  {
    value: 'client',
    label: 'Owner / Client',
    labelEs: 'Cliente',
    icon: 'cli',
    trad: 'client'
  },
  {
    value: 'change',
    label: 'Change Management',
    labelEs: 'Cambio de Alcance',
    icon: 'cha',
    trad: 'change'
  }
];

export const categoriesCncType = [
  {
    value: 'activity',
    label: 'Predecessor',
    labelEs: 'Actividad Predecesora',
    icon: 'ap',
    trad: 'predecessor'
  },
  {
    value: 'design',
    label: 'Design',
    labelEs: 'Diseño',
    icon: 'ds',
    trad: 'design'
  },
  {
    value: 'rrhh',
    label: 'Labor',
    labelEs: 'Mano de Obra',
    icon: 'mo',
    trad: 'labor'
  },
  {
    value: 'machinery',
    label: 'Equipment',
    labelEs: 'Equipos / Maquinaria',
    icon: 'ma',
    trad: 'machinery_and_equipment'
  },
  {
    value: 'material',
    label: 'Material',
    labelEs: 'Materiales',
    icon: 'mat',
    trad: 'materials'
  },
  {
    value: 'permissions',
    label: 'Permit',
    labelEs: 'Permisos',
    icon: 'pe',
    trad: 'permits'
  },
  {
    value: 'ambient',
    label: 'Environment',
    labelEs: 'Medio Ambiente',
    icon: 'me',
    trad: 'environment'
  },
  {
    value: 'risks',
    label: 'Safety',
    labelEs: 'Seguridad',
    icon: 'sg',
    trad: 'security'
  },
  {
    value: 'quality',
    label: 'Quality',
    labelEs: 'Inspección / Calidad',
    icon: 'ca',
    trad: 'quality'
  },
  {
    value: 'plan',
    label: 'Planning',
    labelEs: 'Planificación',
    icon: 'pl',
    trad: 'plan'
  },
  {
    value: 'weather',
    label: 'Weather',
    labelEs: 'Clima',
    icon: 'cl',
    trad: 'weather'
  },
  {
    value: 'others',
    label: 'Others',
    labelEs: 'Otros',
    icon: 'ot',
    trad: 'others'
  },
  {
    value: 'contract',
    label: 'Contract',
    labelEs: 'Contratos',
    icon: 'con',
    trad: 'contract'
  },
  {
    value: 'client',
    label: 'Owner / Client',
    labelEs: 'Cliente',
    icon: 'cli',
    trad: 'client'
  },
  {
    value: 'change',
    label: 'Change Management',
    labelEs: 'Cambio de Alcance',
    icon: 'cha',
    trad: 'change'
  }
];

export const constraintStatus = [
  {
    color: '#b2b2b2',
    value: 'draft',
    label: 'Borrador',
    description: 'Draft status means...',
    visible: true,
    weigth: 3,
    order: 2
  },
  {
    color: '#34af00',
    value: 'released',
    label: 'Liberada',
    description: 'Release status means...',
    visible: true,
    weigth: 3,
    order: 5
  },
  {
    color: '#F59d04',
    value: 'notreleased',
    label: 'Por Liberar',
    description: 'Not Release status means...',
    visible: true,
    weigth: 2,
    order: 4
  },
  {
    color: '#e50101',
    value: 'expired',
    label: 'Vencida',
    description: 'Expired status means...',
    visible: false,
    weigth: 1,
    order: 1
  },
  {
    color: '#586666',
    value: 'notcompromises',
    label: 'Sin Compromiso',
    description: 'Not Compromise status means...',
    visible: false,
    weigth: 0,
    order: 3
  }
];

export const cncStatus = [
  { value: 'resolved', label: 'Resolved' },
  { value: 'unsolved', label: 'No Liberada' },
  { value: 'inprocess', label: 'In process' }
];

export const resourceTypes = [
  { value: 'material', label: 'Material' },
  { value: 'machinery', label: 'Maquinaria' },
  { value: 'rrhh', label: 'Especialidades' }
];

export const MsgErrorDB = (type) => {
  let msg;
  switch (type) {
    case 'users_email_key':
      msg = 'email_exists';
      break;
    case 'user_not_confirm':
      msg = 'email_not_confirm';
      break;
    case 'minlength':
      msg = 'password_min';
      break;
    case 'email_reset_sent':
      msg = 'password_reset';
      break;
    case 'email_not_send':
      msg = 'error_send_email';
      break;
    case 'error_reset':
      msg = 'error_build_reset';
      break;
    case 'user_not_exist':
      msg = 'email_not_exists';
      break;
    case 'password_not_valid':
      msg = 'error_password';
      break;
    default:
      msg = 'error_default';
      break;
  }
  return msg;
};

export const openNotification = (dataNotification, duration = 3) => {
  notification.config({
    duration
  });
  const { type, title, description, key } = dataNotification;
  notification[type]({
    message: title,
    description: description,
    style: { zIndex: 999999 },
    key
  });
};

/** This function gives us the object to create the type of notification provided */
export const getTypeNotification = (icon = null, type = 'withoutTitleIcon') => {
  let notifconfig;
  switch (type) {
    case 'withoutTitleIcon':
      notifconfig = {
        icon: icon,
        className: 'massive-notification'
      };
      break;
    case 'withTitleIcon':
      notifconfig = {
        icon: icon,
        className: 'notification-with-title-icon'
      };
      break;
    default:
      break;
  }
  return notifconfig;
};

/**
 * This functions shows a pretty alert to user for massive actions in gantt
 * @param {*} data Object { title, description, style, type }
 * @param {*} type Object { icon, className }
 */
export const notifyMessageCustom = (data, duration = 3) => {
  const defaultStyle = {
    width: 401,
    height: 'auto'
  };
  const defaultClassName = `massive-notification ${data?.className}`;
  const defaultIcon = null;
  notification.destroy();
  const config = {
    className: data?.type?.className || defaultClassName,
    duration: duration,
    icon: data?.type?.icon || defaultIcon,
    description: data.description || '',
    style: data?.style || defaultStyle
  };
  if (data.title) config.message = data.title;
  notification.open(config);
};

// function to generate object form for select andt
// name: name of field (name in form)
// label: label for message validation
// value: value of field (handle hook) (undefined or false set valid=false )
// typeValidation: type of validation (required)
export function generateFormObjectSelect(
  name,
  label,
  value,
  typeValidation = 'required'
) {
  return {
    value: value,
    valid: Boolean(value),
    fieldName: name,
    requiredTxt: `${label} is ${typeValidation}`
  };
}

export function validateEmail(email) {
  // eslint-disable-next-line no-useless-escape
  if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,4})+$/.test(email)) {
    return true;
  }
  return false;
}

export const groupBy = (array, key) =>
  array.reduce((result, currentValue) => {
    (result[currentValue[key]] = result[currentValue[key]] || []).push(
      currentValue
    );
    return result;
  }, {});

/** this function get sum of array grouped by field */
export const getSumGroupBy = (arr, field = 'currency') => {
  const grouped = arr.reduce((a, c) => {
    const name = c[field];
    a[name] = a[name]
      ? ((a[name].sum += c.budget), a[name])
      : { sum: c.budget, field: c[field] };
    return a;
  }, []);
  return Object.values(grouped);
};

export const compareValues =
  (key, order = 'asc') =>
  (a, b) => {
    // eslint-disable-next-line no-prototype-builtins
    if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) {
      // property doesn't exist on either object
      return 0;
    }

    const varA = typeof a[key] === 'string' ? a[key].toUpperCase() : a[key];
    const varB = typeof b[key] === 'string' ? b[key].toUpperCase() : b[key];

    let comparison = 0;
    if (varA > varB) {
      comparison = 1;
    } else if (varA < varB) {
      comparison = -1;
    }
    return order === 'desc' ? comparison * -1 : comparison;
  };

export const generateNumber = (min, max) =>
  Math.floor(Math.random() * (max - min + 1) + min);

export const codeCountries = [
  {
    name: 'Afghanistan',
    dial_code: '+93',
    code: 'AF'
  },
  {
    name: 'Aland Islands',
    dial_code: '+358',
    code: 'AX'
  },
  {
    name: 'Albania',
    dial_code: '+355',
    code: 'AL'
  },
  {
    name: 'Algeria',
    dial_code: '+213',
    code: 'DZ'
  },
  {
    name: 'AmericanSamoa',
    dial_code: '+1684',
    code: 'AS'
  },
  {
    name: 'Andorra',
    dial_code: '+376',
    code: 'AD'
  },
  {
    name: 'Angola',
    dial_code: '+244',
    code: 'AO'
  },
  {
    name: 'Anguilla',
    dial_code: '+1264',
    code: 'AI'
  },
  {
    name: 'Antarctica',
    dial_code: '+672',
    code: 'AQ'
  },
  {
    name: 'Antigua and Barbuda',
    dial_code: '+1268',
    code: 'AG'
  },
  {
    name: 'Argentina',
    dial_code: '+54',
    code: 'AR'
  },
  {
    name: 'Armenia',
    dial_code: '+374',
    code: 'AM'
  },
  {
    name: 'Aruba',
    dial_code: '+297',
    code: 'AW'
  },
  {
    name: 'Australia',
    dial_code: '+61',
    code: 'AU'
  },
  {
    name: 'Austria',
    dial_code: '+43',
    code: 'AT'
  },
  {
    name: 'Azerbaijan',
    dial_code: '+994',
    code: 'AZ'
  },
  {
    name: 'Bahamas',
    dial_code: '+1242',
    code: 'BS'
  },
  {
    name: 'Bahrain',
    dial_code: '+973',
    code: 'BH'
  },
  {
    name: 'Bangladesh',
    dial_code: '+880',
    code: 'BD'
  },
  {
    name: 'Barbados',
    dial_code: '+1246',
    code: 'BB'
  },
  {
    name: 'Belarus',
    dial_code: '+375',
    code: 'BY'
  },
  {
    name: 'Belgium',
    dial_code: '+32',
    code: 'BE'
  },
  {
    name: 'Belize',
    dial_code: '+501',
    code: 'BZ'
  },
  {
    name: 'Benin',
    dial_code: '+229',
    code: 'BJ'
  },
  {
    name: 'Bermuda',
    dial_code: '+1441',
    code: 'BM'
  },
  {
    name: 'Bhutan',
    dial_code: '+975',
    code: 'BT'
  },
  {
    name: 'Bolivia, Plurinational State of',
    dial_code: '+591',
    code: 'BO'
  },
  {
    name: 'Bosnia and Herzegovina',
    dial_code: '+387',
    code: 'BA'
  },
  {
    name: 'Botswana',
    dial_code: '+267',
    code: 'BW'
  },
  {
    name: 'Brazil',
    dial_code: '+55',
    code: 'BR'
  },
  {
    name: 'British Indian Ocean Territory',
    dial_code: '+246',
    code: 'IO'
  },
  {
    name: 'Brunei Darussalam',
    dial_code: '+673',
    code: 'BN'
  },
  {
    name: 'Bulgaria',
    dial_code: '+359',
    code: 'BG'
  },
  {
    name: 'Burkina Faso',
    dial_code: '+226',
    code: 'BF'
  },
  {
    name: 'Burundi',
    dial_code: '+257',
    code: 'BI'
  },
  {
    name: 'Cambodia',
    dial_code: '+855',
    code: 'KH'
  },
  {
    name: 'Cameroon',
    dial_code: '+237',
    code: 'CM'
  },
  {
    name: 'Canada',
    dial_code: '+1',
    code: 'CA'
  },
  {
    name: 'Cape Verde',
    dial_code: '+238',
    code: 'CV'
  },
  {
    name: 'Cayman Islands',
    dial_code: '+ 345',
    code: 'KY'
  },
  {
    name: 'Central African Republic',
    dial_code: '+236',
    code: 'CF'
  },
  {
    name: 'Chad',
    dial_code: '+235',
    code: 'TD'
  },
  {
    name: 'Chile',
    dial_code: '+56',
    code: 'CL'
  },
  {
    name: 'China',
    dial_code: '+86',
    code: 'CN'
  },
  {
    name: 'Christmas Island',
    dial_code: '+61',
    code: 'CX'
  },
  {
    name: 'Cocos (Keeling) Islands',
    dial_code: '+61',
    code: 'CC'
  },
  {
    name: 'Colombia',
    dial_code: '+57',
    code: 'CO'
  },
  {
    name: 'Comoros',
    dial_code: '+269',
    code: 'KM'
  },
  {
    name: 'Congo',
    dial_code: '+242',
    code: 'CG'
  },
  {
    name: 'Congo, The Democratic Republic of the Congo',
    dial_code: '+243',
    code: 'CD'
  },
  {
    name: 'Cook Islands',
    dial_code: '+682',
    code: 'CK'
  },
  {
    name: 'Costa Rica',
    dial_code: '+506',
    code: 'CR'
  },
  {
    name: "Cote d'Ivoire",
    dial_code: '+225',
    code: 'CI'
  },
  {
    name: 'Croatia',
    dial_code: '+385',
    code: 'HR'
  },
  {
    name: 'Cuba',
    dial_code: '+53',
    code: 'CU'
  },
  {
    name: 'Cyprus',
    dial_code: '+357',
    code: 'CY'
  },
  {
    name: 'Czech Republic',
    dial_code: '+420',
    code: 'CZ'
  },
  {
    name: 'Denmark',
    dial_code: '+45',
    code: 'DK'
  },
  {
    name: 'Djibouti',
    dial_code: '+253',
    code: 'DJ'
  },
  {
    name: 'Dominica',
    dial_code: '+1767',
    code: 'DM'
  },
  {
    name: 'Dominican Republic',
    dial_code: '+1849',
    code: 'DO'
  },
  {
    name: 'Ecuador',
    dial_code: '+593',
    code: 'EC'
  },
  {
    name: 'Egypt',
    dial_code: '+20',
    code: 'EG'
  },
  {
    name: 'El Salvador',
    dial_code: '+503',
    code: 'SV'
  },
  {
    name: 'Equatorial Guinea',
    dial_code: '+240',
    code: 'GQ'
  },
  {
    name: 'Eritrea',
    dial_code: '+291',
    code: 'ER'
  },
  {
    name: 'Estonia',
    dial_code: '+372',
    code: 'EE'
  },
  {
    name: 'Ethiopia',
    dial_code: '+251',
    code: 'ET'
  },
  {
    name: 'Falkland Islands (Malvinas)',
    dial_code: '+500',
    code: 'FK'
  },
  {
    name: 'Faroe Islands',
    dial_code: '+298',
    code: 'FO'
  },
  {
    name: 'Fiji',
    dial_code: '+679',
    code: 'FJ'
  },
  {
    name: 'Finland',
    dial_code: '+358',
    code: 'FI'
  },
  {
    name: 'France',
    dial_code: '+33',
    code: 'FR'
  },
  {
    name: 'French Guiana',
    dial_code: '+594',
    code: 'GF'
  },
  {
    name: 'French Polynesia',
    dial_code: '+689',
    code: 'PF'
  },
  {
    name: 'Gabon',
    dial_code: '+241',
    code: 'GA'
  },
  {
    name: 'Gambia',
    dial_code: '+220',
    code: 'GM'
  },
  {
    name: 'Georgia',
    dial_code: '+995',
    code: 'GE'
  },
  {
    name: 'Germany',
    dial_code: '+49',
    code: 'DE'
  },
  {
    name: 'Ghana',
    dial_code: '+233',
    code: 'GH'
  },
  {
    name: 'Gibraltar',
    dial_code: '+350',
    code: 'GI'
  },
  {
    name: 'Greece',
    dial_code: '+30',
    code: 'GR'
  },
  {
    name: 'Greenland',
    dial_code: '+299',
    code: 'GL'
  },
  {
    name: 'Grenada',
    dial_code: '+1473',
    code: 'GD'
  },
  {
    name: 'Guadeloupe',
    dial_code: '+590',
    code: 'GP'
  },
  {
    name: 'Guam',
    dial_code: '+1671',
    code: 'GU'
  },
  {
    name: 'Guatemala',
    dial_code: '+502',
    code: 'GT'
  },
  {
    name: 'Guernsey',
    dial_code: '+44',
    code: 'GG'
  },
  {
    name: 'Guinea',
    dial_code: '+224',
    code: 'GN'
  },
  {
    name: 'Guinea-Bissau',
    dial_code: '+245',
    code: 'GW'
  },
  {
    name: 'Guyana',
    dial_code: '+595',
    code: 'GY'
  },
  {
    name: 'Haiti',
    dial_code: '+509',
    code: 'HT'
  },
  {
    name: 'Holy See (Vatican City State)',
    dial_code: '+379',
    code: 'VA'
  },
  {
    name: 'Honduras',
    dial_code: '+504',
    code: 'HN'
  },
  {
    name: 'Hong Kong',
    dial_code: '+852',
    code: 'HK'
  },
  {
    name: 'Hungary',
    dial_code: '+36',
    code: 'HU'
  },
  {
    name: 'Iceland',
    dial_code: '+354',
    code: 'IS'
  },
  {
    name: 'India',
    dial_code: '+91',
    code: 'IN'
  },
  {
    name: 'Indonesia',
    dial_code: '+62',
    code: 'ID'
  },
  {
    name: 'Iran, Islamic Republic of Persian Gulf',
    dial_code: '+98',
    code: 'IR'
  },
  {
    name: 'Iraq',
    dial_code: '+964',
    code: 'IQ'
  },
  {
    name: 'Ireland',
    dial_code: '+353',
    code: 'IE'
  },
  {
    name: 'Isle of Man',
    dial_code: '+44',
    code: 'IM'
  },
  {
    name: 'Israel',
    dial_code: '+972',
    code: 'IL'
  },
  {
    name: 'Italy',
    dial_code: '+39',
    code: 'IT'
  },
  {
    name: 'Jamaica',
    dial_code: '+1876',
    code: 'JM'
  },
  {
    name: 'Japan',
    dial_code: '+81',
    code: 'JP'
  },
  {
    name: 'Jersey',
    dial_code: '+44',
    code: 'JE'
  },
  {
    name: 'Jordan',
    dial_code: '+962',
    code: 'JO'
  },
  {
    name: 'Kazakhstan',
    dial_code: '+77',
    code: 'KZ'
  },
  {
    name: 'Kenya',
    dial_code: '+254',
    code: 'KE'
  },
  {
    name: 'Kiribati',
    dial_code: '+686',
    code: 'KI'
  },
  {
    name: "Korea, Democratic People's Republic of Korea",
    dial_code: '+850',
    code: 'KP'
  },
  {
    name: 'Korea, Republic of South Korea',
    dial_code: '+82',
    code: 'KR'
  },
  {
    name: 'Kuwait',
    dial_code: '+965',
    code: 'KW'
  },
  {
    name: 'Kyrgyzstan',
    dial_code: '+996',
    code: 'KG'
  },
  {
    name: 'Laos',
    dial_code: '+856',
    code: 'LA'
  },
  {
    name: 'Latvia',
    dial_code: '+371',
    code: 'LV'
  },
  {
    name: 'Lebanon',
    dial_code: '+961',
    code: 'LB'
  },
  {
    name: 'Lesotho',
    dial_code: '+266',
    code: 'LS'
  },
  {
    name: 'Liberia',
    dial_code: '+231',
    code: 'LR'
  },
  {
    name: 'Libyan Arab Jamahiriya',
    dial_code: '+218',
    code: 'LY'
  },
  {
    name: 'Liechtenstein',
    dial_code: '+423',
    code: 'LI'
  },
  {
    name: 'Lithuania',
    dial_code: '+370',
    code: 'LT'
  },
  {
    name: 'Luxembourg',
    dial_code: '+352',
    code: 'LU'
  },
  {
    name: 'Macao',
    dial_code: '+853',
    code: 'MO'
  },
  {
    name: 'Macedonia',
    dial_code: '+389',
    code: 'MK'
  },
  {
    name: 'Madagascar',
    dial_code: '+261',
    code: 'MG'
  },
  {
    name: 'Malawi',
    dial_code: '+265',
    code: 'MW'
  },
  {
    name: 'Malaysia',
    dial_code: '+60',
    code: 'MY'
  },
  {
    name: 'Maldives',
    dial_code: '+960',
    code: 'MV'
  },
  {
    name: 'Mali',
    dial_code: '+223',
    code: 'ML'
  },
  {
    name: 'Malta',
    dial_code: '+356',
    code: 'MT'
  },
  {
    name: 'Marshall Islands',
    dial_code: '+692',
    code: 'MH'
  },
  {
    name: 'Martinique',
    dial_code: '+596',
    code: 'MQ'
  },
  {
    name: 'Mauritania',
    dial_code: '+222',
    code: 'MR'
  },
  {
    name: 'Mauritius',
    dial_code: '+230',
    code: 'MU'
  },
  {
    name: 'Mayotte',
    dial_code: '+262',
    code: 'YT'
  },
  {
    name: 'Mexico',
    dial_code: '+52',
    code: 'MX'
  },
  {
    name: 'Micronesia, Federated States of Micronesia',
    dial_code: '+691',
    code: 'FM'
  },
  {
    name: 'Moldova',
    dial_code: '+373',
    code: 'MD'
  },
  {
    name: 'Monaco',
    dial_code: '+377',
    code: 'MC'
  },
  {
    name: 'Mongolia',
    dial_code: '+976',
    code: 'MN'
  },
  {
    name: 'Montenegro',
    dial_code: '+382',
    code: 'ME'
  },
  {
    name: 'Montserrat',
    dial_code: '+1664',
    code: 'MS'
  },
  {
    name: 'Morocco',
    dial_code: '+212',
    code: 'MA'
  },
  {
    name: 'Mozambique',
    dial_code: '+258',
    code: 'MZ'
  },
  {
    name: 'Myanmar',
    dial_code: '+95',
    code: 'MM'
  },
  {
    name: 'Namibia',
    dial_code: '+264',
    code: 'NA'
  },
  {
    name: 'Nauru',
    dial_code: '+674',
    code: 'NR'
  },
  {
    name: 'Nepal',
    dial_code: '+977',
    code: 'NP'
  },
  {
    name: 'Netherlands',
    dial_code: '+31',
    code: 'NL'
  },
  {
    name: 'Netherlands Antilles',
    dial_code: '+599',
    code: 'AN'
  },
  {
    name: 'New Caledonia',
    dial_code: '+687',
    code: 'NC'
  },
  {
    name: 'New Zealand',
    dial_code: '+64',
    code: 'NZ'
  },
  {
    name: 'Nicaragua',
    dial_code: '+505',
    code: 'NI'
  },
  {
    name: 'Niger',
    dial_code: '+227',
    code: 'NE'
  },
  {
    name: 'Nigeria',
    dial_code: '+234',
    code: 'NG'
  },
  {
    name: 'Niue',
    dial_code: '+683',
    code: 'NU'
  },
  {
    name: 'Norfolk Island',
    dial_code: '+672',
    code: 'NF'
  },
  {
    name: 'Northern Mariana Islands',
    dial_code: '+1670',
    code: 'MP'
  },
  {
    name: 'Norway',
    dial_code: '+47',
    code: 'NO'
  },
  {
    name: 'Oman',
    dial_code: '+968',
    code: 'OM'
  },
  {
    name: 'Pakistan',
    dial_code: '+92',
    code: 'PK'
  },
  {
    name: 'Palau',
    dial_code: '+680',
    code: 'PW'
  },
  {
    name: 'Palestinian Territory, Occupied',
    dial_code: '+970',
    code: 'PS'
  },
  {
    name: 'Panama',
    dial_code: '+507',
    code: 'PA'
  },
  {
    name: 'Papua New Guinea',
    dial_code: '+675',
    code: 'PG'
  },
  {
    name: 'Paraguay',
    dial_code: '+595',
    code: 'PY'
  },
  {
    name: 'Peru',
    dial_code: '+51',
    code: 'PE'
  },
  {
    name: 'Philippines',
    dial_code: '+63',
    code: 'PH'
  },
  {
    name: 'Pitcairn',
    dial_code: '+872',
    code: 'PN'
  },
  {
    name: 'Poland',
    dial_code: '+48',
    code: 'PL'
  },
  {
    name: 'Portugal',
    dial_code: '+351',
    code: 'PT'
  },
  {
    name: 'Puerto Rico',
    dial_code: '+1939',
    code: 'PR'
  },
  {
    name: 'Qatar',
    dial_code: '+974',
    code: 'QA'
  },
  {
    name: 'Romania',
    dial_code: '+40',
    code: 'RO'
  },
  {
    name: 'Russia',
    dial_code: '+7',
    code: 'RU'
  },
  {
    name: 'Rwanda',
    dial_code: '+250',
    code: 'RW'
  },
  {
    name: 'Reunion',
    dial_code: '+262',
    code: 'RE'
  },
  {
    name: 'Saint Barthelemy',
    dial_code: '+590',
    code: 'BL'
  },
  {
    name: 'Saint Helena, Ascension and Tristan Da Cunha',
    dial_code: '+290',
    code: 'SH'
  },
  {
    name: 'Saint Kitts and Nevis',
    dial_code: '+1869',
    code: 'KN'
  },
  {
    name: 'Saint Lucia',
    dial_code: '+1758',
    code: 'LC'
  },
  {
    name: 'Saint Martin',
    dial_code: '+590',
    code: 'MF'
  },
  {
    name: 'Saint Pierre and Miquelon',
    dial_code: '+508',
    code: 'PM'
  },
  {
    name: 'Saint Vincent and the Grenadines',
    dial_code: '+1784',
    code: 'VC'
  },
  {
    name: 'Samoa',
    dial_code: '+685',
    code: 'WS'
  },
  {
    name: 'San Marino',
    dial_code: '+378',
    code: 'SM'
  },
  {
    name: 'Sao Tome and Principe',
    dial_code: '+239',
    code: 'ST'
  },
  {
    name: 'Saudi Arabia',
    dial_code: '+966',
    code: 'SA'
  },
  {
    name: 'Senegal',
    dial_code: '+221',
    code: 'SN'
  },
  {
    name: 'Serbia',
    dial_code: '+381',
    code: 'RS'
  },
  {
    name: 'Seychelles',
    dial_code: '+248',
    code: 'SC'
  },
  {
    name: 'Sierra Leone',
    dial_code: '+232',
    code: 'SL'
  },
  {
    name: 'Singapore',
    dial_code: '+65',
    code: 'SG'
  },
  {
    name: 'Slovakia',
    dial_code: '+421',
    code: 'SK'
  },
  {
    name: 'Slovenia',
    dial_code: '+386',
    code: 'SI'
  },
  {
    name: 'Solomon Islands',
    dial_code: '+677',
    code: 'SB'
  },
  {
    name: 'Somalia',
    dial_code: '+252',
    code: 'SO'
  },
  {
    name: 'South Africa',
    dial_code: '+27',
    code: 'ZA'
  },
  {
    name: 'South Sudan',
    dial_code: '+211',
    code: 'SS'
  },
  {
    name: 'South Georgia and the South Sandwich Islands',
    dial_code: '+500',
    code: 'GS'
  },
  {
    name: 'Spain',
    dial_code: '+34',
    code: 'ES'
  },
  {
    name: 'Sri Lanka',
    dial_code: '+94',
    code: 'LK'
  },
  {
    name: 'Sudan',
    dial_code: '+249',
    code: 'SD'
  },
  {
    name: 'Suriname',
    dial_code: '+597',
    code: 'SR'
  },
  {
    name: 'Svalbard and Jan Mayen',
    dial_code: '+47',
    code: 'SJ'
  },
  {
    name: 'Swaziland',
    dial_code: '+268',
    code: 'SZ'
  },
  {
    name: 'Sweden',
    dial_code: '+46',
    code: 'SE'
  },
  {
    name: 'Switzerland',
    dial_code: '+41',
    code: 'CH'
  },
  {
    name: 'Syrian Arab Republic',
    dial_code: '+963',
    code: 'SY'
  },
  {
    name: 'Taiwan',
    dial_code: '+886',
    code: 'TW'
  },
  {
    name: 'Tajikistan',
    dial_code: '+992',
    code: 'TJ'
  },
  {
    name: 'Tanzania, United Republic of Tanzania',
    dial_code: '+255',
    code: 'TZ'
  },
  {
    name: 'Thailand',
    dial_code: '+66',
    code: 'TH'
  },
  {
    name: 'Timor-Leste',
    dial_code: '+670',
    code: 'TL'
  },
  {
    name: 'Togo',
    dial_code: '+228',
    code: 'TG'
  },
  {
    name: 'Tokelau',
    dial_code: '+690',
    code: 'TK'
  },
  {
    name: 'Tonga',
    dial_code: '+676',
    code: 'TO'
  },
  {
    name: 'Trinidad and Tobago',
    dial_code: '+1868',
    code: 'TT'
  },
  {
    name: 'Tunisia',
    dial_code: '+216',
    code: 'TN'
  },
  {
    name: 'Turkey',
    dial_code: '+90',
    code: 'TR'
  },
  {
    name: 'Turkmenistan',
    dial_code: '+993',
    code: 'TM'
  },
  {
    name: 'Turks and Caicos Islands',
    dial_code: '+1649',
    code: 'TC'
  },
  {
    name: 'Tuvalu',
    dial_code: '+688',
    code: 'TV'
  },
  {
    name: 'Uganda',
    dial_code: '+256',
    code: 'UG'
  },
  {
    name: 'Ukraine',
    dial_code: '+380',
    code: 'UA'
  },
  {
    name: 'United Arab Emirates',
    dial_code: '+971',
    code: 'AE'
  },
  {
    name: 'United Kingdom',
    dial_code: '+44',
    code: 'GB'
  },
  {
    name: 'United States',
    dial_code: '+1',
    code: 'US'
  },
  {
    name: 'Uruguay',
    dial_code: '+598',
    code: 'UY'
  },
  {
    name: 'Uzbekistan',
    dial_code: '+998',
    code: 'UZ'
  },
  {
    name: 'Vanuatu',
    dial_code: '+678',
    code: 'VU'
  },
  {
    name: 'Venezuela, Bolivarian Republic of Venezuela',
    dial_code: '+58',
    code: 'VE'
  },
  {
    name: 'Vietnam',
    dial_code: '+84',
    code: 'VN'
  },
  {
    name: 'Virgin Islands, British',
    dial_code: '+1284',
    code: 'VG'
  },
  {
    name: 'Virgin Islands, U.S.',
    dial_code: '+1340',
    code: 'VI'
  },
  {
    name: 'Wallis and Futuna',
    dial_code: '+681',
    code: 'WF'
  },
  {
    name: 'Yemen',
    dial_code: '+967',
    code: 'YE'
  },
  {
    name: 'Zambia',
    dial_code: '+260',
    code: 'ZM'
  },
  {
    name: 'Zimbabwe',
    dial_code: '+263',
    code: 'ZW'
  }
];

export const ObjectLogoSvg = () => (
  <svg width="140" height="140" fill="currentColor" viewBox="0 0 170 170">
    <g transform="translate(-1394 -374)">
      <g transform="translate(118 183)">
        <circle
          cx="85"
          cy="85"
          r="85"
          transform="translate(1276 191)"
          fill="#4CB7C6"
        />
      </g>
      <path
        d="M17132.785,22178.441v-.264l37-34.373.75-.58.447-.283.43-.1h.809l.371.1.439.172,1.035.691,19.266,19.738,45.539-48.289,1.191-.467a4.382,4.382,0,0,1,1.736-.447,4.464,4.464,0,0,1,1.752.447l31.484,33.469-.016.348c-5.68,38.164-37.764,67.395-76.492,67.395C17170.779,22216,17146.443,22200.992,17132.785,22178.441Z"
        transform="translate(-15719 -21682)"
        fill="#FEFEFE"
      />
      <circle
        cx="20.5"
        cy="20.5"
        r="20.5"
        transform="translate(1418 409)"
        fill="#FEFEFE"
      />
    </g>
  </svg>
);

export const ObjectNewLogoSvg = () => (
  <svg
    width="186"
    height="140"
    viewBox="0 0 186 140"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <g filter="url(#filter0_d_1217_351)">
      <rect
        width="186"
        height="140"
        rx="5"
        fill="#EFEFEF"
        shape-rendering="crispEdges"
      />
      <path
        d="M111 84V56C111 53.8 109.2 52 107 52H79C76.8 52 75 53.8 75 56V84C75 86.2 76.8 88 79 88H107C109.2 88 111 86.2 111 84ZM86.8 73.96L91 79.02L97.2 71.04C97.6 70.52 98.4 70.52 98.8 71.06L105.82 80.42C105.931 80.5686 105.999 80.7452 106.016 80.9302C106.033 81.1152 105.997 81.3011 105.914 81.4672C105.831 81.6333 105.704 81.773 105.546 81.8707C105.388 81.9683 105.206 82.02 105.02 82.02H81.04C80.2 82.02 79.74 81.06 80.26 80.4L85.24 74C85.62 73.48 86.38 73.46 86.8 73.96Z"
        fill="#C4C4C4"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_1217_351"
        x="0"
        y="0"
        width="186"
        height="140"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB">
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_1217_351"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_1217_351"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

export const ObjectNewLogoOwnerSvg = () => (
  <svg
    width="186"
    height="60"
    viewBox="0 0 186 60"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <g filter="url(#filter0_d_1218_359)">
      <rect
        width="186"
        height="60"
        rx="5"
        fill="#EFEFEF"
        shape-rendering="crispEdges"
      />
      <path
        d="M106.5 40.5V19.5C106.5 17.85 105.15 16.5 103.5 16.5H82.5C80.85 16.5 79.5 17.85 79.5 19.5V40.5C79.5 42.15 80.85 43.5 82.5 43.5H103.5C105.15 43.5 106.5 42.15 106.5 40.5ZM88.35 32.97L91.5 36.765L96.15 30.78C96.45 30.39 97.05 30.39 97.35 30.795L102.615 37.815C102.699 37.9264 102.749 38.0589 102.762 38.1976C102.774 38.3364 102.748 38.4758 102.686 38.6004C102.624 38.725 102.528 38.8298 102.409 38.903C102.291 38.9762 102.154 39.015 102.015 39.015H84.03C83.4 39.015 83.055 38.295 83.445 37.8L87.18 33C87.465 32.61 88.035 32.595 88.35 32.97Z"
        fill="#C4C4C4"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_1218_359"
        x="0"
        y="0"
        width="186"
        height="60"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB">
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_1218_359"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_1218_359"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

/** Logic for Drag & Drop Behavior for Sectors */
export const ListElement = styled.div`
  z-index: 9999;
  text-align: center;
  width: 64%;
  display: inline-block;
`;

/** This function get real url based on data for uploaded image */
export const getBase64 = (img, callback) => {
  const reader = new FileReader();
  reader.addEventListener('load', () => callback(reader.result));
  reader.readAsDataURL(img);
};

/** constant to define header when submitting forms */
export const headersSendForm = {
  Authorization:
    'Basic cHJvcGxhbm5lcjpiWGx0WVhOMFpYSnJaWGx0ZVcxaGMzUmxjbXRsZVcxNWJXRnpkR1Z5YTJWNU1USXpORFUyTnpnNU1UQmhZbU5rWldabmFHbHE=',
  'Access-Control-Allow-Origin': '*',
  'Access-Control-Allow-Credentials': 'true'
};

/** this function set title of layout wide  */
export const setTitleWide = (view) => {
  const TITLE_PROFILE = 'Create your <span id="spanActive">Profile</span>';
  const TITLE_COMPANY = 'Create your <span id="spanActive">Company</span>';
  const TITLE_PROJECT_CONFIRMATION =
    'Create your <span id="spanActive">First Project</span>';
  const TITLE_STAGE =
    'Create the <span id="spanActive">Schedules</span> of your project';
  const TITLE_INVITE = 'Invite your <span id="spanActive">Team</span>';
  const TITLE_PASSWORD = 'Change your <span id="spanActive">Password</span>';

  let msg;
  switch (view) {
    case 'confirmation':
      msg = TITLE_PROFILE;
      break;
    case 'company':
      msg = TITLE_COMPANY;
      break;
    case 'project':
      msg = TITLE_PROJECT_CONFIRMATION;
      break;
    case 'stage':
      msg = TITLE_STAGE;
      break;
    case 'invite':
      msg = TITLE_INVITE;
      break;
    case 'password':
      msg = TITLE_PASSWORD;
      break;
    default:
      msg = 'Error';
      break;
  }
  document.getElementById('titleHeader').innerHTML = msg;
};

/** icons svg */
export const crane =
  'M938.652 170.626V127.956h-170.654v42.672h-42.688v-96.5L618.686 0.068 512 74.126v96.5H71.128L0.004 341.282H170.66l-0.032 106.656h-8.532l-34.094 33.766v115.542h42.624v7.532a302.98 302.98 0 0 0-16.968 20.218c-17.282 22.718-25.656 41.562-25.656 57.624 0 39.438 24.594 64 64.218 64 42.876 0 60.844-51.562 62.75-57.438 3.624-11.188-2.5-23.25-13.718-26.906-11.188-3.656-23.218 2.468-26.844 13.656-3.812 11.438-13.906 28-22.188 28-15.906 0-21.562-5.562-21.562-21.312 0-9.438 17.032-34.812 36.406-54.25l6.25-6.25v-24.876h42.688v-115.48l-33.844-33.828h-8.844V341.28H512v639.964H298.69c-11.782 0-21.344 9.562-21.344 21.376 0 11.75 9.562 21.312 21.344 21.312h639.962c11.782 0 21.344-9.562 21.344-21.312 0-11.812-9.562-21.376-21.344-21.376H725.31V341.282h42.688v42.672h170.654v-42.672c21.376 0 40.062-9.876 54.062-28.53 9.688-12.906 17.312-30.266 22.624-51.624 8.562-34.156 8.656-67.766 8.656-69.188V170.626h-85.342zM213.346 554.624H170.66V499.5l9-8.89h24.842l8.844 8.844v55.17z m290.372-341.34l-23.75 71.266-28.438-28.438 42.844-42.828h9.344z m-82.342 12.656l-12.656-12.656h25.312l-12.656 12.656z m-30.188 30.172l-32.468 32.5-32.5-32.5 32.5-32.5 32.468 32.5z m-95.124-30.172l-12.656-12.656h25.312l-12.656 12.656z m-62.688-2.328l32.5 32.5-32.5 32.5-32.5-32.5 32.5-32.5z m-62.654 2.328l-12.656-12.656h25.312l-12.656 12.656z m12.312 72.686H158.378l12.344-12.344 12.312 12.344z m113.03-12.342l12.344 12.344H283.72l12.344-12.344z m125.312 0l12.344 12.344h-24.688l12.344-12.344z m127.342-73h48.624v85.344H520.28l28.438-85.344z m103.094 127.998l-33.124 33.156-33.188-33.156h66.312z m30.844-42.656H640v-85.344h42.656v85.344z m-94.156 105.998l-33.844 33.828V370.78l33.844 33.844z m30.188 30.172l55.25 55.266-55.25 55.25-55.282-55.266 55.282-55.25zM588.5 575.5l-33.844 33.808v-67.636l33.844 33.828z m30.188 30.184l55.25 55.25-55.25 55.25-55.282-55.25 55.282-55.25z m-30.188 140.688l-33.844 33.844V712.56l33.844 33.812z m30.188 30.186l55.25 55.282-55.25 55.25-55.282-55.25 55.282-55.282z m-30.188 140.72l-33.844 33.844v-67.688l33.844 33.844z m30.188 30.156l33.782 33.812h-67.624l33.842-33.812z m30.124-30.156l33.844-33.844v67.688l-33.844-33.844z m0-170.906l33.844-33.812v67.656l-33.844-33.844z m0-170.872l33.844-33.828v67.636l-33.844-33.808z m0-170.876l33.844-33.844v67.672l-33.844-33.828zM618.688 52.02l63.968 44.42v74.188h-128V96.44l64.032-44.42zM99.034 214.58l41.5 41.532-42.468 42.516H64.004l35.03-84.048z m626.276 84.046v-85.344h42.688v85.344h-42.688z m170.686 42.656h-85.342V170.626h85.342v170.656z m77.968-90.514c-5.468 21.828-16.032 47.86-35.312 47.86v-85.344h41.468c-0.998 10.656-2.812 24.108-6.156 37.484z';
export const dollar =
  'M545.024 176v66.645333l4.544 0.682667c28.16 4.202667 50.986667 12.778667 68.736 25.813333 15.658667 11.52 30.72 28.522667 45.184 50.901334l3.2 4.906666-62.293333 32.469334-2.645334-3.968c-21.888-32.853333-49.984-49.322667-84.032-49.322667-22.890667 0-42.048 6.442667-57.173333 19.157333-15.466667 13.013333-23.274667 29.376-23.274667 48.810667 0 17.706667 6.421333 32.682667 19.029334 44.458667 10.24 9.557333 29.12 20.416 57.344 32.938666l21.546666 9.301334c25.877333 11.264 47.253333 21.738667 64.341334 31.530666 18.944 10.922667 33.130667 21.354667 42.453333 31.210667 26.922667 27.093333 40.277333 59.52 40.277333 97.792 0 37.674667-12.117333 70.848-36.352 99.648-24 28.693333-56.192 48-96.64 58.069333l-4.053333 1.002667v69.952h-53.802667v-68.330667l-4.522666-0.704c-47.018667-7.210667-82.858667-22.229333-107.306667-45.056-22.613333-21.12-39.786667-53.034667-51.541333-95.637333l-1.536-5.546667 70.826666-13.824 1.514667 4.373334c10.816 31.146667 23.808 53.76 38.848 67.797333 17.92 15.317333 41.301333 22.933333 70.485333 22.933333 28.352 0 52.138667-8.597333 71.296-25.728 19.050667-17.130667 28.672-39.338667 28.672-66.218666 0-24.170667-8.106667-43.776-24.064-58.453334-7.893333-6.954667-19.242667-14.570667-34.773333-23.36a541.333333 541.333333 0 0 0-48.896-23.893333l-15.786667-6.784c-42.709333-18.474667-71.168-35.413333-84.672-50.474667-23.082667-24.192-34.517333-52.8-34.517333-86.293333 0-15.808 2.688-30.528 8.106667-44.224a123.157333 123.157333 0 0 1 23.488-36.992c10.176-10.922667 22.890667-20.629333 37.994666-28.970667 14.997333-8.106667 32.384-14.570667 52.096-19.392l4.053334-1.002666V176h53.845333z';
export const dashboard =
  'M273.066667 392.533333h8.533333c32.853333 0 59.733333 26.88 59.733333 59.733334v298.666666c0 32.853333-26.88 59.733333-59.733333 59.733334h-8.533333c-32.853333 0-59.733333-26.88-59.733334-59.733334v-298.666666c0-32.853333 26.88-59.733333 59.733334-59.733334zM512 213.333333c32.853333 0 59.733333 26.88 59.733333 59.733334v477.866666c0 32.853333-26.88 59.733333-59.733333 59.733334-32.853333 0-59.733333-26.88-59.733333-59.733334V273.066667c0-32.853333 26.88-59.733333 59.733333-59.733334z m238.933333 341.333334c32.853333 0 59.733333 26.88 59.733334 59.733333v136.533333c0 32.853333-26.88 59.733333-59.733334 59.733334-32.853333 0-59.733333-26.88-59.733333-59.733334v-136.533333c0-32.853333 26.88-59.733333 59.733333-59.733333z';
export const area = 'M959.333 959.333h-896v-896z';
export const handshake =
  'M1080,251v340.2c0,0-70.2,16.2-86.4,16.2s-59.4,16.2-91.8-16.2c-48.6-48.6-232.2-237.6-232.2-237.6s-27-32.4-75.6-5.4l-81,48.6c-27,16.2-70.2,5.4-86.4-21.6l0,0c-21.6-32.4-10.8-75.6,21.6-91.8c64.8-37.8,167.4-97.2,205.2-118.8c32.4-21.6,59.4-21.6,108,21.6c59.4,48.6,108,97.2,108,97.2s21.6,10.8,43.2,10.8C950.4,283.4,1080,251,1080,251z M426.6,839.6c-16.2-16.2-199.8-216-216-232.2c-21.6-27-64.8-21.6-91.8,0c-27,27-43.2,75.6-21.6,102.6c21.6,27,189,205.2,216,232.2c21.6,27,81,16.2,108-10.8C448.2,904.4,453.6,861.2,426.6,839.6z M842.4,726.2c27-27,21.6-75.6-5.4-102.6c-145.8-151.2-91.8-91.8-189-194.4c0,0-32.4-37.8-70.2-16.2c-10.8,5.4-27,16.2-48.6,27c-48.6,32.4-113.4,16.2-145.8-37.8l-16.2-10.8c-32.4-54-16.2-118.8,32.4-151.2l91.8-59.4c0,0-21.6-32.4-86.4-32.4c-64.8,0-199.8,97.2-199.8,97.2s-43.2,27-97.2,5.4L0,213.2V602c0,0,32.4,10.8,59.4,21.6c5.4-16.2,16.2-37.8,32.4-48.6c43.2-43.2,124.2-48.6,162,0c27,27,199.8,216,216,232.2c27,27,32.4,64.8,27,97.2C507.6,915.2,739.8,839.6,842.4,726.2z';
export const constraint_alert =
  'M986.8,351.2c-24.4-57.8-59.4-109.6-104-154.1c-44.5-44.5-96.4-79.6-154.1-104c-59.8-25.3-123.3-38.2-188.8-38.2s-129,12.8-188.8,38.2c-57.8,24.4-109.6,59.4-154.1,104c-44.5,44.5-79.6,96.4-104,154.1C67.6,411,54.8,474.5,54.8,540S67.6,669,93,728.8c24.4,57.8,59.4,109.6,104,154.1c44.5,44.5,96.4,79.6,154.1,104c59.8,25.3,123.3,38.2,188.8,38.2s129-12.8,188.8-38.2c57.8-24.4,109.6-59.4,154.1-104c44.5-44.5,79.6-96.4,104-154.1C1012.1,669,1025,605.5,1025,540C1025,474.5,1012.2,411,986.8,351.2z M489.3,235.2c0-28,22.7-50.7,50.7-50.7c28,0,50.7,22.7,50.7,50.7v394.1c0,28-22.7,50.7-50.7,50.7c-28,0-50.7-22.7-50.7-50.7V235.2z M540,895.5c-41.9,0-76-34-76-76s34-76,76-76s76,34,76,76S581.9,895.5,540,895.5z';
export const group =
  'M1007.6,1031.4H540c-11,0-20-9-20-20V543.8c0-11,9-20,20-20h467.6c11,0,20,9,20,20v467.6C1027.6,1022.4,1018.6,1031.4,1007.6,1031.4z M560,991.4h427.6V563.8H560V991.4z M444.1,770c0-11-9-20-20-20h-97.9V322.4h427.6v113c0,11,9,20,20,20s20-9,20-20v-133c0-11-9-20-20-20H306.2c-11,0-20,9-20,20V770c0,11,9,20,20,20h117.9C435.1,790,444.1,781,444.1,770z M211,536.2c0-11-9-20-20-20H92.4V88.6H520v105.5c0,11,9,20,20,20s20-9,20-20V68.6c0-11-9-20-20-20H72.4c-11,0-20,9-20,20v467.6c0,11,9,20,20,20H191C202,556.2,211,547.2,211,536.2';
export const date =
  'M1050.8,317c0-0.1,0-0.1,0-0.2V159.2c0-11-9-20-20-20h-77.5V72.4c0-11-9-20-20-20s-20,9-20,20v66.8H151.2V72.4c0-11-9-20-20-20s-20,9-20,20v66.8h-62c-11,0-20,9-20,20v526.3v122.4v199.8c0,11,9,20,20,20h981.6c11,0,20-9,20-20V583.4V461V317.2C1050.8,317.2,1050.8,317.1,1050.8,317z M1010.8,179.2V297H69.2V179.2H1010.8z M69.2,705.4h378.1v82.4H69.2V705.4z M69.2,987.6V827.8h398.1c11,0,20-9,20-20V685.4c0-11-9-20-20-20H69.2V337h941.6v104H612.7c-11,0-20,9-20,20v122.4c0,11,9,20,20,20h398.1v384.2H69.2z M1010.8,563.4H632.7V481h378.1V563.4z';
export const filter =
  'M611.8,1037.3c-5.2,0-10.3-2-14.1-5.9L370.4,804.2c-3.8-3.8-5.9-8.8-5.9-14.1V505.7L17.2,75.2c-4.8-6-5.8-14.2-2.5-21.2c3.3-6.9,10.3-11.4,18-11.4c0,0,0,0,0,0l1014.5,0.5c8.1,0,15.4,4.9,18.5,12.4s1.4,16.1-4.3,21.8L631.8,506.9v510.4c0,8.1-4.9,15.4-12.3,18.5C617,1036.9,614.4,1037.3,611.8,1037.3z M404.5,781.8l187.3,187.3V498.6c0-5.3,2.1-10.4,5.9-14.1L999,83.1L74.6,82.7l325.5,403.4c2.9,3.6,4.4,8,4.4,12.6V781.8z';
export const order =
  'M196.7,770.2c3.6,6.2,3.6,13.8,0,20l-54.3,94c-3.6,6.2-10.2,10-17.3,10c-7.1,0-13.7-3.8-17.3-10l-54.3-94c-3.6-6.2-3.6-13.8,0-20s10.2-10,17.3-10H105V193.6c0-11,9-20,20-20s20,9,20,20v566.5h34.3C186.4,760.1,193,763.9,196.7,770.2z M1023.5,173.6H331.1c-11,0-20,9-20,20s9,20,20,20h692.3c11,0,20-9,20-20S1034.5,173.6,1023.5,173.6z M956.5,384.8H331.1c-11,0-20,9-20,20s9,20,20,20h625.3c11,0,20-9,20-20S967.5,384.8,956.5,384.8z M860.5,595.9H331.1c-11,0-20,9-20,20s9,20,20,20h529.3c11,0,20-9,20-20S871.5,595.9,860.5,595.9z M779.2,807.1H331.1c-11,0-20,9-20,20s9,20,20,20h448.1c11,0,20-9,20-20S790.3,807.1,779.2,807.1z';
export const columns =
  'M1054.5,546.3c-0.2,0.3-0.4,0.6-0.6,0.8c-0.1,0.1-0.2,0.3-0.3,0.4c-57.6,74.2-117.2,136.2-177.1,184.3c-3.7,3-8.1,4.4-12.5,4.4c-5.9,0-11.7-2.6-15.6-7.5c-6.9-8.6-5.5-21.2,3.1-28.1c54.2-43.5,108.3-99.1,160.9-165.4C855.5,337.8,691.5,240.9,524.8,247.2c-11,0.4-20.3-8.2-20.7-19.2c-0.4-11,8.2-20.3,19.2-20.7c183.7-7,362.1,99.2,530.3,315.8c0.1,0.1,0.2,0.3,0.3,0.4c0.2,0.3,0.4,0.5,0.6,0.8c0.2,0.3,0.4,0.6,0.5,0.9c0.2,0.3,0.3,0.5,0.5,0.8c0.2,0.3,0.3,0.7,0.5,1c0.1,0.2,0.2,0.5,0.3,0.7c0.2,0.4,0.3,0.7,0.4,1.1c0.1,0.2,0.1,0.5,0.2,0.7c0.1,0.4,0.2,0.8,0.3,1.2c0.1,0.2,0.1,0.5,0.2,0.7c0.1,0.4,0.1,0.8,0.2,1.2c0,0.3,0.1,0.5,0.1,0.8c0,0.4,0.1,0.7,0.1,1.1c0,0.3,0,0.6,0,0.9c0,0.3,0,0.6,0,0.9c0,0.4,0,0.7-0.1,1.1c0,0.3-0.1,0.5-0.1,0.8c-0.1,0.4-0.1,0.8-0.2,1.2c0,0.2-0.1,0.5-0.2,0.7c-0.1,0.4-0.2,0.8-0.3,1.2c-0.1,0.2-0.1,0.5-0.2,0.7c-0.1,0.4-0.3,0.7-0.4,1.1c-0.1,0.2-0.2,0.5-0.3,0.7c-0.2,0.3-0.3,0.7-0.5,1c-0.1,0.3-0.3,0.5-0.5,0.8C1054.8,545.8,1054.6,546,1054.5,546.3z M872.9,951.7c6.4,9,4.3,21.5-4.7,27.9c-3.5,2.5-7.6,3.7-11.6,3.7c-6.3,0-12.4-2.9-16.3-8.4L727.2,815.7c-1.7,5.6-5.8,10.5-11.7,12.9c-57.8,23.4-116.5,35.1-175.4,35.1c-34,0-68.1-3.9-102.2-11.8c-73.8-17-147.3-52.4-218.3-105.1C100.4,658.3,29.5,552.3,25.6,546.4c0,0,0,0,0,0c0,0,0-0.1-0.1-0.1c-0.1-0.2-0.2-0.3-0.3-0.5c-0.2-0.4-0.5-0.8-0.7-1.2c-0.2-0.3-0.3-0.6-0.5-1c-0.1-0.3-0.3-0.5-0.4-0.8c-0.2-0.4-0.3-0.8-0.4-1.2c-0.1-0.2-0.1-0.4-0.2-0.6c-0.1-0.4-0.2-0.9-0.3-1.3c0-0.2-0.1-0.4-0.1-0.6c-0.1-0.4-0.1-0.8-0.2-1.3c0-0.2-0.1-0.4-0.1-0.7c0-0.4-0.1-0.8-0.1-1.1c0-0.3,0-0.6,0-0.8c0-0.3,0-0.6,0-0.9c0-0.3,0-0.7,0.1-1c0-0.3,0.1-0.5,0.1-0.8c0.1-0.4,0.1-0.8,0.2-1.2c0-0.2,0.1-0.5,0.2-0.7c0.1-0.4,0.2-0.8,0.3-1.2c0.1-0.3,0.2-0.5,0.3-0.8c0.1-0.4,0.2-0.7,0.4-1c0.1-0.4,0.3-0.7,0.5-1c0.1-0.2,0.2-0.5,0.3-0.7c0.3-0.5,0.6-1.1,0.9-1.6c0,0,0-0.1,0.1-0.1c0,0,0,0,0,0c0-0.1,0.1-0.1,0.1-0.2c2.4-3.6,31.1-46.5,81.8-100.1c47.9-50.7,125.3-120.8,221.8-166.9c0.2-0.1,0.4-0.2,0.7-0.3l-91.3-128.5c-6.4-9-4.3-21.5,4.7-27.9c9-6.4,21.5-4.3,27.9,4.7L660.6,653c0,0,0,0,0.1,0.1c0,0,0,0.1,0,0.1L872.9,951.7z M393.1,524.6c0,83.7,68.1,151.7,151.7,151.7c25,0,49.1-6,70.8-17.5L441.4,413.6C410.9,442.2,393.1,482.4,393.1,524.6z M709,790.1L639,691.7c-28.6,16.2-60.8,24.7-94.2,24.7c-105.7,0-191.7-86-191.7-191.7c0-55.2,24-107.6,65-143.8l-65.5-92.1c-1.7,1.8-3.7,3.4-6.1,4.5c-90.7,43.3-163.9,109.7-209.4,157.7c-34.7,36.6-58.9,68.4-70.5,84.5c21.2,29.2,84.8,111.3,177.6,180c151.1,111.8,304.6,137.4,456.2,76.2C703.3,790.4,706.1,789.9,709,790.1z';
export const grid =
  'M944.6,101.9H135.5c-18.8,0-34,15.2-34,34v193c-0.2,1-0.3,2-0.3,3.1s0.1,2.1,0.3,3.1v202.2c-0.2,1-0.3,2-0.3,3.1s0.1,2.1,0.3,3.1v211.3c-0.2,1-0.3,2-0.3,3.1s0.1,2.1,0.3,3.1V945c0,18.8,15.2,34,34,34h809.1c18.8,0,34-15.2,34-34V135.9C978.6,117.1,963.4,101.9,944.6,101.9z M944.6,523.4H357.2V349h587.4V523.4z M323.2,523.4H135.5V349h187.7V523.4z M135.5,557.4h187.7v183.4H135.5V557.4z M357.2,557.4h587.4v183.4H357.2V557.4z M944.6,315H357.2V135.9h587.4V315z M323.2,135.9V315H135.5V135.9H323.2z M135.5,774.8h187.7V945H135.5V774.8z M357.2,945V774.8h587.4V945H357.2z';
export const redo =
  'M969.9,732.4C934,808.5,877.6,873,806.8,918.9c-72.7,47.1-157.2,71.9-244.2,71.9c-60.7,0-119.6-11.9-175.1-35.4c-53.6-22.7-101.7-55.1-143-96.5s-73.8-89.5-96.5-143c-23.5-55.5-35.4-114.4-35.4-175.1s11.9-119.6,35.4-175.1c22.7-53.6,55.1-101.7,96.5-143s89.5-73.8,143-96.5c55.5-23.5,114.4-35.4,175.1-35.4c49.8,0,98.7,8.1,145.4,24c45.1,15.4,87.4,37.9,125.7,66.7c1,0.7,1.9,1.5,2.6,2.4l59.5-54.2c4.7-4.2,11.2-5.7,17.3-3.8c6,1.9,10.5,6.9,11.9,13.1l20.4,93.7l20.4,93.7c1.3,6.2-0.7,12.6-5.4,16.9c-3.3,3-7.6,4.6-11.9,4.6c-1.8,0-3.6-0.3-5.4-0.8l-182.7-58.3c-6-1.9-10.5-6.9-11.9-13.1c-1.3-6.2,0.7-12.6,5.4-16.9l56-51c-71.9-53.5-157.3-81.8-247.3-81.8c-228.6,0-414.6,186-414.6,414.6s186,414.6,414.6,414.6c159.8,0,307.1-93.5,375.2-238.1c4.2-8.8,14.7-12.7,23.5-8.5C970.2,713,974,723.5,969.9,732.4z';
export const undo =
  'M112.9,732.4C148.8,808.5,205.2,873,276,918.9c72.7,47.1,157.2,71.9,244.2,71.9c60.7,0,119.6-11.9,175.1-35.4c53.6-22.7,101.7-55.1,143-96.5c41.3-41.3,73.8-89.5,96.5-143c23.5-55.5,35.4-114.4,35.4-175.1s-11.9-119.6-35.4-175.1c-22.7-53.6-55.1-101.7-96.5-143s-89.5-73.8-143-96.5c-55.5-23.5-114.4-35.4-175.1-35.4c-49.8,0-98.7,8.1-145.4,24c-45.1,15.4-87.4,37.9-125.7,66.7c-1,0.7-1.9,1.5-2.6,2.4L187,129.8c-4.7-4.2-11.2-5.7-17.3-3.8c-6,2-10.5,7-11.9,13.2l-20.4,93.7l-20.4,93.7c-1.3,6.2,0.7,12.6,5.4,16.9c3.3,3,7.6,4.6,11.9,4.6c1.8,0,3.6-0.3,5.4-0.8l182.7-58.4c6-1.9,10.5-6.9,11.9-13.1c1.3-6.2-0.7-12.6-5.4-16.9l-56-51c71.9-53.5,157.3-81.8,247.3-81.8c228.6,0.1,414.6,186,414.6,414.6s-186,414.6-414.6,414.6c-159.8,0-307.1-93.5-375.2-238.1c-4.2-8.8-14.7-12.7-23.5-8.5C112.6,713,108.8,723.5,112.9,732.4z';
export const hide_mov =
  'M988.7,540c0,63.4-12.4,125-36.9,182.9c-23.7,56-57.6,106.2-100.7,149.4c-43.2,43.2-93.4,77-149.4,100.7c-58,24.5-119.5,36.9-182.9,36.9c-90.9,0-179.1-26-255-75.2c-74-47.9-132.9-115.2-170.4-194.8c-4.7-10-0.4-21.9,9.6-26.6c10-4.7,21.9-0.4,26.6,9.6c70.7,150,223.5,247,389.2,247c237.1,0,430-192.9,430-430s-192.9-430-430-430c-92.7,0-180.7,28.9-254.9,83.7l56.9,51.7c5.3,4.8,7.6,12.1,6.1,19.1c-1.5,7-6.7,12.6-13.5,14.8L123,340c-2,0.6-4,0.9-6.1,0.9c-4.9,0-9.7-1.8-13.5-5.2c-5.3-4.8-7.6-12.1-6.1-19.1l42.6-195.1c1.5-7,6.7-12.6,13.5-14.8c6.8-2.2,14.3-0.5,19.5,4.3l60.8,55.4c0.6-0.6,1.2-1.1,1.8-1.6c39.9-30.2,84.1-53.6,131.2-69.7C415.6,78.4,466.7,70,518.7,70c63.4,0,125,12.4,183,36.9c56,23.7,106.2,57.6,149.4,100.7c43.2,43.2,77,93.4,100.7,149.4C976.2,415,988.7,476.5,988.7,540z M330.2,692c3.2,0,6.4-0.8,9.4-2.4l236.3-125.9c6.5-3.5,10.6-10.3,10.6-17.7V320.9c0-11-9-20-20-20s-20,9-20,20v213.2L320.8,654.4c-9.7,5.2-13.4,17.3-8.2,27.1C316.1,688.2,323.1,692,330.2,692z';
export const import_gantt =
  'M1010,812.8v139.3c0,11-9,20-20,20H90c-11,0-20-9-20-20V812.8c0-11,9-20,20-20s20,9,20,20v119.3h860V812.8c0-11,9-20,20-20S1010,801.7,1010,812.8z M286.5,338.9L520,167.4v622.7c0,11,9,20,20,20s20-9,20-20V167.8l245.9,183.6c3.6,2.7,7.8,4,12,4c6.1,0,12.1-2.8,16-8c6.6-8.8,4.8-21.4-4.1-28L552,111.9c-7.1-5.3-16.7-5.3-23.8-0.1L262.9,306.7c-8.9,6.5-10.8,19.1-4.3,28C265.1,343.5,277.6,345.4,286.5,338.9z';
export const export_file =
  'M911.6,329.4L664.1,81.9c-0.5-0.5-1-0.9-1.5-1.3c-0.1-0.1-0.2-0.2-0.4-0.3c-0.4-0.3-0.8-0.6-1.2-0.9c-0.1-0.1-0.2-0.1-0.4-0.2c-0.4-0.3-0.9-0.5-1.3-0.8c-0.1,0-0.2-0.1-0.3-0.1c-0.5-0.3-1-0.5-1.5-0.7c-0.1,0-0.1,0-0.2-0.1c-0.5-0.2-1.1-0.4-1.7-0.6c-0.1,0-0.1,0-0.2-0.1c-0.6-0.2-1.1-0.3-1.7-0.4c-0.2,0-0.3,0-0.5-0.1c-0.5-0.1-1-0.2-1.4-0.2c-0.7-0.1-1.3-0.1-2-0.1H178c-11,0-20,9-20,20v854.1c0,11,9,20,20,20h390.2c11,0,20-9,20-20s-9-20-20-20H198V116h432v238.1c0,11,9,20,20,20h227.5v380.5c0,11,9,20,20,20s20-9,20-20v-411C917.4,338.2,915.3,333.1,911.6,329.4z M669.9,144.3l189.8,189.8H669.9V144.3z M269.7,501.8c0-11,9-20,20-20h495.4c11,0,20,9,20,20s-9,20-20,20H289.7C278.7,521.8,269.7,512.9,269.7,501.8z M269.7,628.2c0-11,9-20,20-20h495.4c11,0,20,9,20,20s-9,20-20,20H289.7C278.7,648.2,269.7,639.2,269.7,628.2z M269.7,757.4c0-11,9-20,20-20h330.7c11,0,20,9,20,20s-9,20-20,20H289.7C278.7,777.4,269.7,768.5,269.7,757.4z M879.9,872.2c7.8,7.8,7.8,20.5,0,28.3l-109.6,109.6c-3.9,3.9-9,5.9-14.1,5.9s-10.2-2-14.1-5.9L635.8,904c-7.8-7.8-7.8-20.5,0-28.3c7.8-7.8,20.5-7.8,28.3,0l75.9,75.9V737.3c0-11,9-20,20-20s20,9,20,20v206.6l71.7-71.7C859.4,864.4,872.1,864.4,879.9,872.2z';
export const gantt_levels =
  'M990,747.2H540c-11,0-20,9-20,20v62.3h-74.8V699.1h424.4c5.5,0,10-4.5,10-10V540c0-5.5-4.5-10-10-10H785v-62.3c0-11-9-20-20-20H315c-11,0-20,9-20,20V530h-74.4V399.5H645c5.5,0,10-4.5,10-10V240.4c0-5.5-4.5-10-10-10h-85v-62.3c0-11-9-20-20-20H90c-11,0-20,9-20,20v144.7c0,11,9,20,20,20h450c11,0,20-9,20-20v-62.3h75v129.1H210.6c-5.5,0-10,4.5-10,10V540c0,5.5,4.5,10,10,10H295v62.3c0,11,9,20,20,20h450c11,0,20-9,20-20V550h74.6v129.1H435.2c-5.5,0-10,4.5-10,10v150.5c0,5.5,4.5,10,10,10H520v62.3c0,11,9,20,20,20h450c11,0,20-9,20-20V767.2C1010,756.2,1001,747.2,990,747.2z M520,292.8H110V188.1h410V292.8z M745,592.3H335V487.7h410V592.3z M970,891.9H560V787.2h410V891.9z';
export const critical_path =
  'M552.5,560h247.6c9.3,46.2,50.2,81,99,81c55.7,0,101-45.3,101-101c0-55.7-45.3-101-101-101c-48.9,0-89.7,34.9-99,81H552.5V191h247.6c9.3,46.2,50.2,81,99,81c55.7,0,101-45.3,101-101c0-55.7-45.3-101-101-101c-48.9,0-89.7,34.9-99,81H532.5c-11,0-20,9-20,20v349H279.9c-9.3-46.2-50.2-81-99-81c-55.7,0-101,45.3-101,101c0,55.7,45.3,101,101,101c48.9,0,89.7-34.9,99-81h232.6v349c0,11,9,20,20,20h267.6c9.3,46.2,50.2,81,99,81c55.7,0,101-45.3,101-101s-45.3-101-101-101c-48.9,0-89.7,34.9-99,81H552.5V560z M899.1,479c33.6,0,61,27.4,61,61s-27.4,61-61,61c-33.6,0-61-27.3-61-60.9c0,0,0-0.1,0-0.1s0-0.1,0-0.1C838.2,506.3,865.5,479,899.1,479z M899.1,110c33.6,0,61,27.4,61,61c0,33.6-27.4,61-61,61c-33.6,0-61-27.3-61-60.9c0,0,0-0.1,0-0.1s0-0.1,0-0.1C838.2,137.3,865.5,110,899.1,110z M180.9,601c-33.6,0-61-27.4-61-61s27.4-61,61-61c33.6,0,61,27.3,61,60.9c0,0,0,0.1,0,0.1s0,0.1,0,0.1C241.8,573.7,214.5,601,180.9,601z M899.1,847.9c33.6,0,61,27.4,61,61s-27.4,61-61,61c-33.6,0-61-27.3-61-60.9c0,0,0-0.1,0-0.1s0-0.1,0-0.1C838.2,875.3,865.5,847.9,899.1,847.9z';
export const links =
  'M610.6,763.8c-36.6,0-73.5-10.7-105.8-33c-41-28.3-68.5-70.9-77.5-120c-9-49,1.7-98.6,30-139.6c6.3-9.1,18.7-11.4,27.8-5.1c9.1,6.3,11.4,18.7,5.1,27.8c-22.3,32.2-30.6,71.2-23.6,109.7c7,38.5,28.7,72,60.9,94.2c66.5,45.9,158,29.2,203.9-37.3L944,352.8c45.9-66.5,29.2-158-37.3-203.9c-32.2-22.3-71.2-30.6-109.7-23.6c-38.5,7-72,28.7-94.2,60.9l-64.6,93.5c-6.3,9.1-18.7,11.4-27.8,5.1c-9.1-6.3-11.4-18.7-5.1-27.8l64.6-93.5c28.3-41,70.9-68.5,120-77.5c49-9,98.6,1.7,139.6,30c84.7,58.5,106,174.9,47.5,259.6L764.4,683.3C728.2,735.7,669.9,763.8,610.6,763.8z M290.2,994.1c49-9,91.6-36.5,120-77.5l67.9-98.3c6.3-9.1,4-21.5-5.1-27.8c-9.1-6.3-21.5-4-27.8,5.1l-67.9,98.3C355,926,321.5,947.7,283,954.7c-38.5,7-77.5-1.3-109.7-23.6c-32.2-22.3-53.8-55.7-60.9-94.2c-7-38.5,1.3-77.5,23.6-109.7l212.5-307.8c22.3-32.2,55.7-53.8,94.2-60.9c38.5-7,77.5,1.3,109.7,23.6c32.2,22.3,53.8,55.7,60.9,94.2c7,38.5-1.3,77.5-23.6,109.7c-6.3,9.1-4,21.5,5.1,27.8c9.1,6.3,21.5,4,27.8-5.1c28.3-41,39-90.6,30-139.6c-9-49-36.5-91.6-77.5-120c-41-28.3-90.6-39-139.6-30c-49,9-91.6,36.5-120,77.5L103.1,704.5c-28.3,41-39,90.6-30,139.6c9,49,36.5,91.6,77.5,119.9c31.5,21.8,68.1,33.1,105.6,33.1C267.5,997.2,278.9,996.1,290.2,994.1z';
export const save =
  'M1004.1,325.9l-250-250c-3.8-3.8-8.8-5.9-14.1-5.9H190c-66.2,0-120,53.8-120,120v700c0,66.2,53.8,120,120,120h700c66.2,0,120-53.8,120-120V340C1010,334.7,1007.9,329.6,1004.1,325.9z M970,890c0,44.1-35.9,80-80,80H190c-44.1,0-80-35.9-80-80V190c0-44.1,35.9-80,80-80h80v230c0,11,9,20,20,20h400c11,0,20-9,20-20s-9-20-20-20H310V110h421.7L970,348.3V890z M540,534.8c-93.7,0-170,76.3-170,170s76.3,170,170,170s170-76.3,170-170S633.7,534.8,540,534.8z M540,834.8c-71.7,0-130-58.3-130-130s58.3-130,130-130c71.7,0,130,58.3,130,130S611.7,834.8,540,834.8z';
export const save_baseline =
  'M766.2,985.4c0,11-9,20-20,20h-552c-65.6,0-119-53.4-119-119V193.5c0-65.6,53.4-119,119-119h544.4c5.3,0,10.4,2.1,14.1,5.9l247.5,247.5c3.8,3.8,5.9,8.8,5.9,14.1v263.7c0,11-9,20-20,20s-20-9-20-20V350.3L730.3,114.6H313.1V322h376c11,0,20,9,20,20s-9,20-20,20h-396c-11,0-20-9-20-20V114.6h-79c-43.6,0-79,35.4-79,79v692.9c0,43.6,35.4,79,79,79h552C757.2,965.4,766.2,974.4,766.2,985.4z M698.5,587.1c0,87.1-70.8,157.9-157.9,157.9s-157.9-70.8-157.9-157.9c0-87.1,70.8-157.9,157.9-157.9S698.5,500,698.5,587.1z M658.5,587.1c0-65-52.9-117.9-117.9-117.9c-65,0-117.9,52.9-117.9,117.9c0,65,52.9,117.9,117.9,117.9C605.6,705,658.5,652.1,658.5,587.1z M760.5,714.6c-11,0-20,9-20,20s9,20,20,20h234.7c11,0,20-9,20-20s-9-20-20-20H760.5z M863.3,856H678.5c-11,0-20,9-20,20s9,20,20,20h184.8c11,0,20-9,20-20S874.4,856,863.3,856z M995.1,785.3H678.5c-11,0-20,9-20,20s9,20,20,20h316.6c11,0,20-9,20-20S1006.2,785.3,995.1,785.3z';
export const analitic_negative_arrow = 'M6 9L11.1962 0H0.803848L6 9Z';
export const helmet =
  'M989.6,715.9c-23.9-19.2-48.1-36.2-61.1-45c-5.8-82.4-19.8-155.7-41.7-218.1c-18.7-53-43.1-98.4-72.6-134.9c-44.9-55.5-88.8-74.2-101.2-78.7L630.7,189c-6.4-3.9-14.2-4.4-21.1-1.4l-46.8,20.8c-20.1-15-62.4-42.6-102.3-42.6c-44.7,0-94.9,43.9-113.7,62H281c-5.6,0-11,2.1-15.2,5.8l-63.4,57c-49.8,33.2-88.6,78.5-115.3,134.5c-21.3,44.6-34.9,96-40.5,152.7c-7.4,74.2,0.9,137.5,5.3,163.7c-29.7,30.3-33.3,56.6-33.6,59.7c-0.9,8.3,2.9,16.4,9.8,21.1c6.9,4.7,15.8,5.3,23.3,1.4c60.2-31.1,131.8-36.1,212.8-14.7c62,16.3,106.4,42.8,106.8,43c1.2,0.7,2.5,1.4,3.9,1.9c5.1,1.9,105.4,38.5,191.8,38.5c19.1,0,37.5-1.8,54.1-6.1c80-20.9,255.2-49.4,377.4-44.2c14.3,0.6,25.6-0.5,34.5-3.4c17.2-5.6,23.3-17.2,25.4-23.6C1066,790.2,1046.2,761.4,989.6,715.9z M1000,796.8c-128.2-5.5-305.7,23.3-390.8,45.6c-73,19.1-200.2-24.5-216.9-30.4c-10-5.8-54.4-30.3-115.3-46.5c-40.2-10.7-79.5-15.6-116.6-14.6c-21.9,0.6-43,3.3-63.3,8c2-4.4,2.6-9.4,1.5-14.2c-0.2-0.7-15.7-74.8-6.7-163.6c11.8-115.9,57.8-201.2,136.9-253.5c0.9-0.6,1.8-1.3,2.7-2.1l24.3-21.8c92,24,293.1,123.7,293.1,123.7c-53.8-65.4-158.1-123.6-219.5-154.1h26.8c6.2,0,12.1-2.5,16.4-7c11.2-11.7,29-27.2,47-38.8c94.3,44.8,250.8,199.9,250.8,199.9c-12.3-37.8-72-132.5-98.3-173.4l27.8-12.4l114.1,112.3l-22.3-74.7c1.8,1.1,3.4,1.8,5.4,2.4c2.2,0.7,42.3,14.4,84.5,68c40.6,51.7,91.3,151.8,102.4,335.2c0.4,7.2,4.2,13.7,10.2,17.6c0.3,0.2,29.9,19.7,60.1,43.4c33.3,26.1,48.2,42.1,54.8,50.9C1006.6,796.9,1003.6,796.9,1000,796.8z';
export const cardEditIcon =
  'M1052.9,1035.3c0,11-9,20-20,20H47.1c-11,0-20-9-20-20s9-20,20-20h985.8 C1043.9,1015.3,1052.9,1024.3,1052.9,1035.3z M48.2,974.2c-4.8-4.8-6.8-11.7-5.3-18.3l55.5-256.6c0.8-3.8,2.7-7.2,5.4-9.9L622.1,171 c0,0,0,0,0,0s0,0,0,0L762.6,30.6c7.8-7.8,20.5-7.8,28.3,0l201.1,201.1c7.8,7.8,7.8,20.5,0,28.3L851.6,400.3c0,0,0,0,0,0s0,0,0,0 L329.6,922.2c-2.8,2.8-6.3,4.7-10.1,5.4l-253.1,52c-1.3,0.3-2.7,0.4-4,0.4C57.1,980.1,52,978,48.2,974.2z M664.6,185.1l172.8,172.8 l112.1-112.1L776.7,73L664.6,185.1z M88.4,934.3l217.2-44.6l503.5-503.5L636.3,213.4L136.2,713.5L88.4,934.3z';
export const cardSaveIcon = `M1004.1,325.9l-250-250c-3.8-3.8-8.8-5.9-14.1-5.9H190c-66.2,0-120,53.8-120,120v700c0,66.2,53.8,120,120,120h700c66.2,0,120-53.8,120-120V340C1010,334.7,1007.9,329.6,1004.1,325.9z M970,890c0,44.1-35.9,80-80,80H190c-44.1,0-80-35.9-80-80V190c0-44.1,35.9-80,80-80h80v230c0,11,9,20,20,20h400c11,0,20-9,20-20s-9-20-20-20H310V110h421.7L970,348.3V890z M540,534.8
c-93.7,0-170,76.3-170,170s76.3,170,170,170s170-76.3,170-170S633.7,534.8,540,534.8z M540,834.8c-71.7,0-130-58.3-130-130
s58.3-130,130-130c71.7,0,130,58.3,130,130S611.7,834.8,540,834.8z`;
export const tagIconSVG =
  '<svg focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M0.409363 5.87389V1.23607C0.444776 0.527453 1.01578 0.00853333 1.64543 0H6.28324C7.02908 0.0463467 7.91959 0.33876 8.39786 0.878533L15.2626 8.51972C15.6939 9.06561 15.7061 9.82104 15.2626 10.2768L9.88931 15.6501C9.36246 16.1267 8.57638 16.1065 8.13226 15.6501L1.28788 7.98849C0.788936 7.39925 0.416243 6.61145 0.409363 5.87389ZM2.4218 3.19744C2.45104 3.88691 2.99492 4.38449 3.6068 4.39265C4.29826 4.36177 4.79384 3.81064 4.80202 3.19744C4.77158 2.50567 4.21763 2.02047 3.6068 2.01244C2.917 2.04125 2.42979 2.58795 2.4218 3.19744Z"></path></svg>';

/** views list of projects */
export const viewsListProjects = [
  { value: 'card', label: 'Vista de tarjeta', iconList: 'CARDVIEW' },
  { value: 'list', label: 'Vista de lista', iconList: 'LISTVIEW' }
];

/** this function sort array (asc or desc by sign -)  */
export const dynamicSort = (property, num = false) => {
  let sortOrder = 1;
  if (property[0] === '-') {
    sortOrder = -1;
    property = property.substr(1);
  }
  if (num) {
    return function (a, b) {
      const result =
        a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
      return result * sortOrder;
    };
  }
  return function (a, b) {
    const result =
      a[property].toLowerCase() < b[property].toLowerCase()
        ? -1
        : a[property].toLowerCase() > b[property].toLowerCase()
          ? 1
          : 0;
    return result * sortOrder;
  };
};

/** this function render icons for categories (constraints & cnc types )  */
export const renderIconCat = (typeImg) => {
  try {
    return require(
      './../assets/img/categories/constraints/' + typeImg + '.svg'
    );
  } catch (e) {
    /** by default */
    return require('./../assets/img/categories/constraints/ds.svg');
  }
};

export const getIconCategories = (code, selected) => {
  const iconDefault = 'ot';
  const icons = {
    ds: <RulerIcon color={selected ? '#121212' : '#FFFFFF'} />,
    mo: <CompanyHelmetIcon color={selected ? '#121212' : '#FFFFFF'} />,
    ma: <MachineryIcon color={selected ? '#121212' : '#FFFFFF'} />,
    mat: <MaterialIcon color={selected ? '#121212' : '#FFFFFF'} />,
    pe: <FileIcon color={selected ? '#121212' : '#FFFFFF'} />,
    pr: <CycleIcon color={selected ? '#121212' : '#FFFFFF'} />,
    me: <EnvironmentIcon color={selected ? '#121212' : '#FFFFFF'} />,
    sg: <SafetyIcon color={selected ? '#121212' : '#FFFFFF'} />,
    ap: <PreviousIcon color={selected ? '#121212' : '#FFFFFF'} />,
    do: <QualityIcon color={selected ? '#121212' : '#FFFFFF'} />,
    ot: <OthersIcon color={selected ? '#121212' : '#FFFFFF'} />,
    sub: <SubmittalIcon color={selected ? '#121212' : '#FFFFFF'} />,
    con: <ContractIcon color={selected ? '#121212' : '#FFFFFF'} />,
    cli: <UserIcon color={selected ? '#121212' : '#FFFFFF'} />,
    cha: <ReorderIcon color={selected ? '#121212' : '#FFFFFF'} />
  };
  return icons[code] || icons[iconDefault];
};

export const replaceLast = (x, y, z) => {
  const a = x.split('');
  a[x.lastIndexOf(y)] = z;
  return a.join('');
};

/** this function return number of week */
export const getWeekNumber = (d) => {
  d = new Date(Number(d));
  d.setHours(0, 0, 0, 0);
  d.setDate(d.getDate() + 4 - (d.getDay() || 7));
  const yearStart = new Date(d.getFullYear(), 0, 1);
  const weekNo = Math.round(((d - yearStart) / 86400000 + 1) / 7);
  return [d.getFullYear(), weekNo];
};

/** this function calculate number of weeks at year */
export const weeksInYear = (year) => {
  const d = new Date(year, 11, 31);
  const week = getWeekNumber(d)[1];
  return week == 1 ? 52 : week;
};

/** card */

export const excludeDeep = (arrayData, excludeTaskId, dateRange) => {
  const ret = arrayData
    .map((el) => {
      const tasksRecursive = recursiveTasks(el.tasks, excludeTaskId, dateRange);
      const newTasks = tasksRecursive.filter(
        (el) => !excludeTaskId.includes(el.id)
      );
      return {
        ...el,
        tasks: newTasks
      };
    })
    .filter((el) => el.tasks.length);
  return ret;
};

/** get tasks recursively */
const recursiveTasks = (array, excludeTaskId, dateRange) => {
  const filterWeek = ['Will', 'Committed'];
  /** return mapped array */
  return array.map((el) => {
    const dateCondition = rangeInWeek(el, dateRange);

    el.children.map((task) => {
      if (excludeTaskId.includes(task.id)) {
        task.showWeeklyPlan = false;
      }
      return task;
    });
    recursiveTasks(el.children, excludeTaskId, dateRange);

    if (el.children.length) {
      const haveChildsVisible = el.children.some(
        (child) => child.showWeeklyPlan
      );
      if (dateCondition && filterWeek.includes(el.lean_status)) {
        el.showWeeklyPlan = haveChildsVisible;
      }
    }
    return el;
  });
};

export const extractTaskDetails = (tasks = []) => {
  const taskIdLinked = [];
  const taskNameLinked = [];

  tasks.forEach(({ id, name }) => {
    taskIdLinked.push(id);
    taskNameLinked.push(name);
  });

  return { taskIdLinked, taskNameLinked };
};

export const belongsToRange = (currentDate, rangesDates) => {
  const offsetTZ = new Date().getTimezoneOffset() / -60;
  const formatDate = 'YYYY/MM/DD';
  const belongs = rangesDates.some((e) => {
    const startDate =
      offsetTZ > 0
        ? moment(e.start, formatDate).utc(offsetTZ)
        : moment(e.start, formatDate);
    const endDate =
      offsetTZ > 0
        ? moment(e.end, formatDate).utc(offsetTZ)
        : moment(e.end, formatDate);
    return currentDate.isBetween(startDate, endDate, 'days', true);
  });
  return belongs;
};

export const getWeeklyInit = (tmpArray) => {
  const weekIni = tmpArray[1] + 1; // This value must be checked each year, depending on number of weeks of that year
  return weekIni;
};

export const getTodayWeekWithPday = (projectState, projectData = null) => {
  /** set initial values */
  let project = projectData;
  if (!project) {
    project = projectState.allProjects.find(
      (pr) => pr.id === projectState.projectSelected
    );
  }
  const pDay = parseInt(project?.planification_day);

  const today = new Date();
  const tmp = getWeekNumber(today);
  const weekIni = getWeeklyInit(tmp);
  const yearInit = parseInt(moment().year());
  const day3ofWeek = moment();

  let planificationDay;
  if (pDay === 0) {
    planificationDay = -1;
  } else {
    planificationDay = pDay - 1;
  }
  const from_date = day3ofWeek.startOf('isoWeek').add('days', planificationDay);
  const to_date = from_date.clone().add(6, 'day');
  const start = from_date.toISOString().split('T')[0].split('-').join('/');
  const end = to_date.toISOString().split('T')[0].split('-').join('/');

  /** ger initial range */
  let rangeIni = {
    start: start,
    end: end,
    week: weekIni,
    today: today,
    year: yearInit
  };

  /** search correct week */
  let found = false;
  let weekSearch = weekIni;
  let yearSearch = yearInit;
  let maxIter = 0;
  while (found === false) {
    // fix bug 2021
    if (maxIter >= 55) {
      return 2;
    }
    const currentDate = moment();
    const belongs = belongsToRange(currentDate, [{ ...rangeIni }]);
    if (belongs) {
      found = belongs;
      weekSearch = rangeIni.week;
      yearSearch = rangeIni.year;
    } else {
      const newStart = moment(rangeIni.start).subtract(7, 'days'); // -7
      const newEnd = moment(rangeIni.end).subtract(7, 'days'); // -7
      const newWeek = parseInt(rangeIni.week) - 1; // -1
      rangeIni = {
        start: newStart,
        end: newEnd,
        week: newWeek,
        today: today,
        year: newStart.year()
      };
    }
    maxIter = Number(maxIter) + 1;
  }
  return weekSearch;
};

export const getTodayWeekWithPdayCommitments = (
  projectState,
  projectData = null
) => {
  /** set initial values */
  let project = projectData;
  if (!project) {
    project = projectState.allProjects.find(
      (pr) => pr.id === projectState.projectSelected
    );
  }
  const pDay = parseInt(project?.planification_day);

  const today = new Date();
  const tmp = getWeekNumber(today);
  const weekIni = getWeeklyInit(tmp);
  const yearInit = parseInt(moment().year());
  const day3ofWeek = moment();

  let planificationDay;
  if (pDay === 0) {
    planificationDay = -1;
  } else {
    planificationDay = pDay - 1;
  }
  const from_date = day3ofWeek.startOf('isoWeek').add('days', planificationDay);
  const to_date = from_date.clone().add(6, 'day');
  const start = from_date.toISOString().split('T')[0].split('-').join('/');
  const end = to_date.toISOString().split('T')[0].split('-').join('/');

  /** ger initial range */
  let rangeIni = {
    start: start,
    end: end,
    week: weekIni,
    today: today,
    year: yearInit
  };

  /** search correct week */
  let found = false;
  let weekSearch = weekIni;
  let yearSearch = yearInit;
  let maxIter = 0;
  while (found === false) {
    // fix bug 2021
    if (maxIter >= 55) {
      return 2;
    }
    const currentDate = moment();
    const belongs = belongsToRange(currentDate, [{ ...rangeIni }]);
    if (belongs) {
      found = belongs;
      weekSearch = rangeIni.week;
      yearSearch = rangeIni.year;
    } else {
      const newStart = moment(rangeIni.start).subtract(7, 'days'); // -7
      const newEnd = moment(rangeIni.end).subtract(7, 'days'); // -7
      const newWeek = parseInt(rangeIni.week) - 1; // -1
      rangeIni = {
        start: newStart,
        end: newEnd,
        week: newWeek,
        today: today,
        year: newStart.year()
      };
    }
    maxIter = Number(maxIter) + 1;
  }
  const tmpRange = cloneDeep(rangeIni);
  tmpRange.start = moment(tmpRange.start).format('YYYY/MM/DD');
  tmpRange.end = moment(tmpRange.end).format('YYYY/MM/DD');
  return rangeIni;
};

export const getYearFromDate = (date, d) => {
  const momentDate = moment(date);
  const saturday = momentDate.clone().day(d);
  return saturday.year();
};

export const getYearFromThursday = (date) => {
  const momentDate = moment(date);
  const thursday = momentDate.clone().isoWeekday(4);
  return thursday.year();
};

export const getWeekNumberFromStartWeek = (date) => {
  if (!date) return null;

  const momentDate = moment(date);
  if (!momentDate.isValid()) return null;

  const monday = momentDate.clone().startOf('isoWeek');
  return monday.isoWeek();
};

export const getDayNumberFromDate = () => {
  const momentDate = moment();
  const dayNumber = momentDate.day();
  return dayNumber;
};

/**
 * This function is used to obtain the range for a specific date, taking into account the planning day
 * @param {*} projectState Object Redux for project. It can be null, if we use the planificationDayPar
 * @param {*} currentDay Date to analyze
 * @param {*} planificationDayPar Project planning day
 * @returns [week, year, range(Date format), range(String format)]
 */
export const getTodayWeekWithPdayAndCurrentDay = (
  projectState,
  currentDay,
  planificationDayPar = null
) => {
  /** set initial values */
  let pDay;
  if (planificationDayPar !== null) {
    pDay = parseInt(planificationDayPar);
  } else {
    const project = projectState.allProjects.find(
      (pr) => pr.id === projectState.projectSelected
    );
    pDay = parseInt(project?.planification_day);
  }

  const today = new Date();
  const weekIni = moment().isoWeek();
  const day3ofWeek = moment(currentDay);
  let planificationDay;
  if (pDay === 0) {
    planificationDay = 0;
  } else {
    planificationDay = pDay - 1;
  }
  const from_date = day3ofWeek.startOf('isoWeek').add('days', planificationDay);
  const to_date = from_date.clone().add(6, 'day');
  if (!currentDay.isBetween(from_date, to_date, 'day', '[]')) {
    from_date.subtract(7, 'days');
    to_date.subtract(7, 'days');
  }
  const start = from_date.toISOString().split('T')[0].split('-').join('/');
  const end = to_date.toISOString().split('T')[0].split('-').join('/');
  /** ger initial range */
  const rangeIni = {
    start: start,
    end: end,
    week: moment(start).isoWeek(),
    today: today,
    year: getYearFromThursday(start)
  };

  /** search correct week */
  const weekSearch = weekIni;
  const yearSearch = moment(currentDay).year();

  const tmpRange = cloneDeep(rangeIni);
  tmpRange.start = moment(tmpRange.start).format('YYYY/MM/DD');
  tmpRange.end = moment(tmpRange.end).format('YYYY/MM/DD');
  return [weekSearch, yearSearch, rangeIni, tmpRange];
};

/** this function update resourses of activity */
export const updateResources = (
  res,
  currentResource,
  updateRender,
  activities
) => {
  const newActs = cloneDeep(activities);
  const resIdUpdate = currentResource.id; // 6
  const resourceUpdate = res.find((el) => el.id === resIdUpdate);
  /** update all activities */
  newActs.map((el) => {
    const resourceIndex = el.activities.findIndex(
      (el) => el.id === resIdUpdate
    );
    el.activities[resourceIndex] = resourceUpdate;
    return el;
  });
  updateRender(newActs);
};

/** this funtion get tasks similar to activities.lookahead */
export const getFlattenActivities = (data) =>
  data
    .reduce((result, next) => {
      result.push(next);
      let name = next.tasks || next.children;
      if (name) {
        result = [...result, ...getFlattenActivities(name)];
        name = [];
      }
      return result;
    }, [])
    .filter((e) => e.correlative_id === undefined)
    .filter((e) => !e.hide);

/** this function get enviroment */
export const getEnvironment = (hardcoded = false) => {
  if (hardcoded) {
    return hardcoded;
  }
  const hostName = window.location.hostname;
  if (hostName && hostName.includes('proplanner.app')) {
    return 'prod';
  } else if (hostName && hostName.includes('app.outbuild.com')) {
    return 'prod';
  }
  return 'local';
};

export const getLookaheadSubModule = () => {
  const currentUrl = window.location.href;

  if (currentUrl.includes('planification')) {
    return 'planning';
  } else if (currentUrl.includes('constraints')) {
    return 'roadblocks';
  }

  return null;
};

/** This function centralizes the update of the allProjects Redux variable  */
export const setAllProjectsGlobal = (
  arrProjects,
  dispatch,
  projectActions,
  projectState,
  reg = true
) => {
  const tmpProyects = arrProjects.sort(dynamicSort('name'));
  dispatch(projectActions.setAllProjects(tmpProyects));
  const timerManager = TimerManagerSingleton.getInstance();

  if (reg) {
    const setPropsCallback = () => {
      /** update state props */
      dispatch(
        projectActions.setProps({
          ...projectState.props,
          timeStampAllProjects: Date().toLocaleString(),
          openAddProject: false
        })
      );
    };
    timerManager.registerAutoTimeout(setPropsCallback, 150, 'setProps');
  }
};

export const reversPathTasks = (path, simbol = '>') => {
  if (path) {
    const pathSplit = path.split('>');

    const pathReverse = pathSplit.reduce((acc, _, idx, path) => {
      acc += path[path.length - idx - 1];

      if (path.length - 1 === idx) return acc;

      acc = `${acc} ${simbol} `;

      return acc;
    }, '');

    return pathReverse;
  }
};

/** get tasks recursively for weekly plan */
export const recursiveTasksFilterWp = (array, filterWeek, dateRange) =>
  /** return mapped array */
  array.map((el) => {
    el.showWeeklyPlan = false;

    /** check condition lean_status && date */
    const dateCondition = rangeInWeek(el, dateRange);
    if (dateCondition && filterWeek.includes(el.lean_status)) {
      el.showWeeklyPlan = true;
    }

    /** check childrens */
    const arrayIter = el.children || el.tasks;
    if (arrayIter) {
      const newData = arrayIter;
      recursiveTasksFilterWp(newData, filterWeek, dateRange);
    }

    /** check if childrens (already recursively evaluated) have showWeeklyPlan true */
    if (el.children?.length) {
      const haveChildsVisible = el.children.some((el) => el.showWeeklyPlan);
      if (dateCondition && filterWeek.includes(el.lean_status)) {
        el.showWeeklyPlan = haveChildsVisible;
        // if (haveChildsVisible) {
        //     el.lean_status = 'Will'
        // }
      }
    }
    return el;
  });

/** get tasks recursively */
export const recursiveTasksFilter = (array, filterWeek, range) => {
  const dateRange = {
    start: moment(range.start).format('YYYY/MM/DD').toString(),
    end: moment(range.end).format('YYYY/MM/DD').toString()
  };
  /** return mapped array */
  return array.map((el) => {
    // if (el.children) {
    //     el.showWeeklyPlan = false
    // } else {
    //     el.showWeeklyPlan = true
    // }
    el.showWeeklyPlan = false;
    const resp = rangeInWeek(el, dateRange);
    if (resp && filterWeek.includes(el.lean_status)) {
      el.showWeeklyPlan = true;
    }
    /** check childrens */
    const arrayIter = el.children || el.tasks;
    if (arrayIter) {
      const newData = arrayIter;
      recursiveTasksFilter(newData, filterWeek, dateRange);
    }
    return el;
  });
};

/** this function determines if the task belongs to the provided range */
const rangeInWeek = (task, range) => {
  /** get range Week */
  const rangeWeek = buildRangeDates(range.start, range.end);
  /** verify if task is in range */
  const resp = rangeWeek.some((dayWeek) =>
    dayWeek.isBetween(task.start_date, task.end_date, 'days', true)
  );
  return resp;
};

/** this function generates a date range between start and end */
const buildRangeDates = (startDate, stopDate) => {
  const dateArray = [];
  let currentDate = moment(startDate);
  while (currentDate < moment(stopDate).clone().add(1, 'days')) {
    dateArray.push(moment(currentDate));
    currentDate = moment(currentDate).add(1, 'days');
  }
  return dateArray;
};

export const recursiveActivityFilter = (array) =>
  /** return mapped array */
  array.map((el) => {
    const tmpArr = [];
    tmpArr.push(el);
    const getFlatten = getFlattenActivities(tmpArr);
    const haveWp = getFlatten.some((el) => el.showWeeklyPlan);
    el.showWeeklyPlan = haveWp;
    return el;
  });

export const getActivitiesforWeeklyPlan = (activities, range) => {
  const lastLevelActivitiesFiltered = activities;
  const filterWeek = ['Will', 'Committed'];
  const activitiesData = recursiveTasksFilterWp(
    lastLevelActivitiesFiltered,
    filterWeek,
    { start: range.start, end: range.end }
  );
  const dataFilterActivities = recursiveActivityFilter(activitiesData);
  const dataFilterActivitiesShow = dataFilterActivities.filter(
    (el) => el.showWeeklyPlan === true
  );
  const activitiesFinal = cloneDeep(dataFilterActivitiesShow).filter(
    (el) => el.tasks.length
  );
  return activitiesFinal;
};

/**
 * This function add 'dataAdd' to array 'key' on local Storage
 * @param {*} key Key identifier on localStorage. e.g. 'indicatorProgress'
 * @param {*} field Field Name for data added. e.g. 'progress'
 * @param {*} dataAdd Data to add. e.g. '45%', 45, object
 * @param {*} project Project object
 */
export const addToLocalStorage = (key, field, dataAdd, project) => {
  if (!project) return false;
  const projectsData = JSON.parse(localStorage.getItem(key));
  const dataToAdd = [];
  if (projectsData) {
    /** add */
    const findIndex = projectsData.findIndex(
      (el) => el.projectId === project.id
    );
    if (findIndex !== -1) {
      // finded
      projectsData[findIndex] = {
        projectId: project.id,
        [field]: dataAdd
      };
    } else {
      projectsData.push({
        projectId: project.id,
        [field]: dataAdd
      });
    }
    localStorage.setItem(key, JSON.stringify(projectsData));
  } else {
    /** add first time */
    dataToAdd.push({
      projectId: project.id,
      [field]: dataAdd
    });
    localStorage.setItem(key, JSON.stringify(dataToAdd));
  }
};
export const getActivitiesforWeeklyPlanForWidget = (activities, range) => {
  const lastLevelActivitiesFiltered = activities;
  const filterWeek = ['Will', 'Committed'];
  const activitiesData = recursiveTasksFilter(
    lastLevelActivitiesFiltered,
    filterWeek,
    { start: range.start, end: range.end }
  );
  const dataFilterActivities = activityFilterWeek(activitiesData, {
    start: range.start,
    end: range.end
  });
  const dataFilterActivitiesShow = dataFilterActivities.filter(
    (el) => el.showWeeklyPlan === true
  );
  const activitiesFinal = cloneDeep(dataFilterActivitiesShow); // .filter(el => el.tasks.length)
  return activitiesFinal;
};

export const getBaseActivitiesforWeeklyPlanForWidget = (activities, range) => {
  const lastLevelActivitiesFiltered = activities;
  // const filterWeek = ['Will', 'Committed']
  // const activitiesData = recursiveTasksFilter(lastLevelActivitiesFiltered, filterWeek, { start: range.start, end: range.end })
  const dataFilterActivities = activityFilterWeek(lastLevelActivitiesFiltered, {
    start: range.start,
    end: range.end
  });
  const dataFilterActivitiesShow = dataFilterActivities.filter(
    (el) => el.showWeeklyPlan === true
  );
  const activitiesFinal = cloneDeep(dataFilterActivitiesShow); // .filter(el => el.tasks.length)
  return activitiesFinal;
};

export const activityFilterWeek = (array, range) => {
  const dateRange = {
    start: moment(range.start).format('YYYY/MM/DD').toString(),
    end: moment(range.end).format('YYYY/MM/DD').toString()
  };
  /** return mapped array */
  return array.map((el) => {
    // if (el.children) {
    //     el.showWeeklyPlan = false
    // } else {
    //     el.showWeeklyPlan = true
    // }
    el.showWeeklyPlan = false;
    const resp = rangeInWeek(el, dateRange);
    if (resp) {
      el.showWeeklyPlan = true;
    }
    return el;
  });
};

export const makeSlug = (urlString, filter) => {
  // Changes, e.g., "Petty theft" to "petty_theft".
  // Remove all these words from the string before URLifying
  let removelist = [];
  if (filter) {
    removelist = [
      'a',
      'an',
      'as',
      'at',
      'before',
      'but',
      'by',
      'for',
      'from',
      'is',
      'in',
      'into',
      'like',
      'of',
      'off',
      'on',
      'onto',
      'per',
      'since',
      'than',
      'the',
      'this',
      'that',
      'to',
      'up',
      'via',
      'het',
      'de',
      'een',
      'en',
      'with'
    ];
  }
  let s = urlString;
  const r = new RegExp('\\b(' + removelist.join('|') + ')\\b', 'gi');
  s = s.replace(r, '');
  s = s.replace(/[^-\w\s]/g, ''); // Remove unneeded characters
  s = s.replace(/^\s+|\s+$/g, ''); // Trim leading/trailing spaces
  s = s.replace(/[-\s]+/g, '-'); // Convert spaces to hyphens
  s = s.toLowerCase(); // Convert to lowercase
  return s; // Trim to first num_chars characters
};

export const saturatedColor = (color, percent = 10) => {
  if (!/^#([0-9a-f]{6}$)/i.test(color))
    throw new Error('Unexpected color format');
  if (percent < 0 || percent > 100) throw new Error('Unexpected color format');

  const saturationFloat = percent / 100;
  const rgbIntensityFloat = [
    parseInt(color.substring(1, 3), 16) / 255,
    parseInt(color.substring(3, 5), 16) / 255,
    parseInt(color.substring(5, 7), 16) / 255
  ];

  const rgbIntensityFloatSorted = rgbIntensityFloat
    .slice(0)
    .sort((a, b) => a - b);
  const maxIntensityFloat = rgbIntensityFloatSorted[2];
  const mediumIntensityFloat = rgbIntensityFloatSorted[1];
  const minIntensityFloat = rgbIntensityFloatSorted[0];

  if (maxIntensityFloat == minIntensityFloat) return color;

  let newMediumIntensityFloat;
  const newMinIntensityFloat = maxIntensityFloat * (1 - saturationFloat);

  if (mediumIntensityFloat == minIntensityFloat)
    newMediumIntensityFloat = newMinIntensityFloat;
  else {
    const intensityProportion =
      (maxIntensityFloat - mediumIntensityFloat) /
      (mediumIntensityFloat - minIntensityFloat);
    newMediumIntensityFloat =
      (intensityProportion * newMinIntensityFloat + maxIntensityFloat) /
      (intensityProportion + 1);
  }

  const newRgbIntensityFloat = [];
  const newRgbIntensityFloatSorted = [
    newMinIntensityFloat,
    newMediumIntensityFloat,
    maxIntensityFloat
  ];

  rgbIntensityFloat.forEach((originalRgb) => {
    const rgbSortedIndex = rgbIntensityFloatSorted.indexOf(originalRgb);
    newRgbIntensityFloat.push(newRgbIntensityFloatSorted[rgbSortedIndex]);
  });

  const floatToHex = (val) =>
    `0${Math.round(val * 255).toString(16)}`.substr(-2);
  const rgb2hex = (rgb) =>
    `#${floatToHex(rgb[0])}${floatToHex(rgb[1])}${floatToHex(rgb[2])}`;

  const newHex = rgb2hex(newRgbIntensityFloat);
  return newHex;
};
export const shadeColor = (color, percent = 10) => {
  let R = parseInt(color.substring(1, 3), 16);
  let G = parseInt(color.substring(3, 5), 16);
  let B = parseInt(color.substring(5, 7), 16);

  R = parseInt((R * (100 + percent)) / 100);
  G = parseInt((G * (100 + percent)) / 100);
  B = parseInt((B * (100 + percent)) / 100);

  R = R < 255 ? R : 255;
  G = G < 255 ? G : 255;
  B = B < 255 ? B : 255;

  const RR = R.toString(16).length == 1 ? '0' + R.toString(16) : R.toString(16);
  const GG = G.toString(16).length == 1 ? '0' + G.toString(16) : G.toString(16);
  const BB = B.toString(16).length == 1 ? '0' + B.toString(16) : B.toString(16);

  return `#${RR}${GG}${BB}`;
};

/**
 * This function get last updated user object, and the subtrade associated if neccesarry
 * @param {*} userFromLocalstorage User from localstorage
 * @returns Object which represent current logged user, and his subtrade associated
 */
export const getUserAndSub = async (userFromLocalstorage) => {
  const userFromDb = await userService.show(userFromLocalstorage.id);
  if (!userFromDb) return;
  const user = userFromDb.user;
  if (user.role !== 'subtrade') return;
  if (!user.subcontractId) {
    return {
      user,
      subtrade: null
    };
  }
  const subtradeFromDB = await subContractService.show(user.subcontractId);
  if (!subtradeFromDB) return;
  const subtrade = subtradeFromDB.subcontract;
  return {
    user,
    subtrade
  };
};

/**
 * This function is called by each createTask function, to add dynamically attributes to added task
 * @returns Object to detructure into added task
 */
export const getDynamicAttributesToCreateTask = async (_) => {
  const currentUserString = localStorage.getItem('user');
  if (!currentUserString) return;
  const currentUserObject = JSON.parse(currentUserString);
  if (!currentUserObject) return;

  const subRole = await getUserAndSub(currentUserObject);

  const finalObject = {};
  if (!subRole) return finalObject;
  if (subRole.subtrade) {
    finalObject.editablePermissionACP = {};
    finalObject.editablePermissionACP.editable = true;
    finalObject.editablePermissionACP.role = 'subtrade';
    finalObject.subcontractId = subRole.subtrade.id;
    finalObject.readonly = false;
  }
  return finalObject;
};

/**
 * This function returns the class to use in the html, according to the current resolution
 * @param {*} width current screen width
 * @returns Class to be used in the html for the project card
 */
export const getClassForCards = (width) => {
  /** resolutions that were reviewed
   * https://hardzone.es/2018/03/03/resoluciones-monitor-cuales-son/
   * https://ant.design/components/grid/
   **/
  let retVal = '';
  switch (true) {
    case width < 576:
      retVal = 'xxs-card';
      break;
    case width >= 576 && width < 768:
      retVal = 'xs-card';
      break;
    case width >= 768 && width < 992:
      retVal = 'sm-card';
      break;
    case width >= 992 && width < 1200:
      retVal = 'md-card';
      break;
    case width >= 1200 && width < 1400:
      retVal = 'lg-card';
      break;
    case width >= 1400 && width < 1600:
      retVal = 'lgm-card';
      break;
    case width >= 1600 && width < 1920:
      retVal = 'xl-card';
      break;
    case width >= 1920 && width < 2560:
      retVal = 'xxl-card';
      break;
    case width >= 2560 && width < 3000:
      retVal = 'xxxl-card';
      break;
    case width >= 3000 && width < 3840:
      retVal = 'xxxlm-card';
      break;
    case width >= 3840 && width < 5120:
      retVal = 'xxxxl-card';
      break;
    case width >= 5120:
      retVal = 'xxxxxl-card';
      break;
    default:
      retVal = 'lg-card';
  }
  return `${retVal}`;
};

export const SvgIcon = (() => {
  // Using memoization to prevent unnecessary filter recalculations for repeated colors
  const memoizedFilters = {};

  return ({ path, color = colors.brandBlue40, className }) => {
    memoizedFilters[color] = memoizedFilters[color] ?? getColorFilters(color);
    return (
      <i className={cn(styles['svg-icon'], className)}>
        <img src={path} style={{ filter: memoizedFilters[color] }} />
      </i>
    );
  };
})();

export const getUserLanguage = () =>
  navigator.language || navigator.userLanguage;

export const fieldsOnlyForGanttView = ['actions', 'roadblocks'];

export const sortArray = (arr) => {
  return arr.slice().sort((a, b) => {
    if (a instanceof Object && b instanceof Object) {
      return a.id - b.id;
    }
    return a > b ? 1 : -1;
  });
};

export const areObjectsEqual = (obj1, obj2) => {
  if (Object.keys(obj1).length !== Object.keys(obj2).length) {
    return false;
  }
  return Object.keys(obj1).every((key) => {
    const val1 = obj1[key];
    const val2 = obj2[key];

    if (val1 instanceof Object && val2 instanceof Object) {
      return areObjectsEqual(val1, val2);
    }

    return val1 === val2;
  });
};

export const areArraysEqual = (arr1, arr2) => {
  if (!Array.isArray(arr1) || !Array.isArray(arr2)) {
    return false;
  }
  if (arr1.length !== arr2.length) {
    return false;
  }

  const sortedArr1 = sortArray(arr1);
  const sortedArr2 = sortArray(arr2);
  const numItemsToCheck = sortedArr1.length;

  for (let i = 0; i < numItemsToCheck; i++) {
    const item1 = sortedArr1[i];
    const item2 = sortedArr2[i];
    if (item1 instanceof Object && item2 instanceof Object) {
      if (!areObjectsEqual(item1, item2)) {
        return false;
      }
    } else if (item1 !== item2) {
      return false;
    }
  }
  return true;
};
